import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import constants from '../ndbk-constants'
import * as d3 from "../components/d3.modified.js"
import NodebookSidebar from '../components/NodebookSidebar';
import NodebookDetails from '../components/NodebookDetails';
import Nodebook from '../components/Nodebook';
import SearchOps from '../components/SearchOps'
import { TemplatesLib } from '../components/TemplatesLib'
import Dropdown from '../components/Dropdown'
import Header from '../components/Header'
import NotFoundPage from '../pages/NotFoundPage';
import 'katex/dist/katex.min.css'

class NodebookPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            onlineUsers: [],
            nodebookInfo: {
                author_id: null,
                group_id: null,
                date_created: null,
                title: '',
                description: '',
                authToken: undefined,
                shareToken: undefined,
                permissions: undefined,
                canEdit: false
            },

            // compare data
            isCompare: undefined !== this.props.match.params.clone_id,
            // data
            nodesData: [],
            templatesData: TemplatesLib,
            linksData: [],
            // "hash" tables
            nodesHashTable: {},
            linksHashTable: {},
            // selection data
            selection: {
                nodes: [],
                links: []
            },
            // view share link
            shareViewLink: undefined,
            // bibtex copy text
            bibtexCopyText: undefined,
            // node url copy text
            copyNodeLink: '',
            // branches
            branchesData: undefined
        }
        // TODO see what can be removed from this.state

        // loading flags/data
        this.loaded = {
            nodes: null,
            links: null,
            cloneNodes: null,
            cloneLinks: null,
        }
        // input
        this.keyPressDict = {
            ctrl: false,
            shift: false,
            alt: false,
            link: false,
        }
        // search
        this.state.searchParams = {
            mode: 'basic',  // 'basic' or 'uber'
            // inputData: ''
        }
        this._refs = {
            ctrls: {

            }
        }

        this.state.dataArrived = false

        this.originalNodebookTitle = undefined
        this.clonedNodebookTitle = undefined

        this.ctxMenuData = {}
        this.nodebookComponentFocus = false;

        this.templatesFieldList = {
            all: "Any",
            title: "Title",
            authors: "Authors",
            year: "Year",
            tags: "Tags",
            keywords: "Keywords",
            publication: "Publication",
            abstract: "Abstract",
            color: "Color",
        }

        this.authLevel = {
            // Use this for integer-based checking of permissions ( ex. permissions > 0 )
            'admin': 10,
            'editor': 5,
            'view': 1,
            'none': 0
        }

        this.zoomLevelMin = 0.1
        this.zoomLevelMax = 5
    }

    componentWillMount() {
        this.requestNodebookInfoData()
        this.requestNodesData()
        this.requestLinksData()

        if (this.state.isCompare) {
            var cloneNdbkId = this.props.match.params.clone_id
            this.requestNodebookInfoData(cloneNdbkId)
            this.requestNodesData(cloneNdbkId)
            this.requestLinksData(cloneNdbkId)
        } else {
            this.requestCloningData()
        }

        if (this.isNoBackground()) {
            document.body.classList.add("no-background")
        }
    }

    componentWillUnmount() {

        document.removeEventListener('copy', null)
        document.removeEventListener('paste', null)
        document.removeEventListener('cut', null)

        // Selection causing problems when switching to new nodebook.
        this.setState({
            selection: {
                nodes: [],
                links: []
            }
        })
        //d3.select(document.body).on('keydown', null).on('keyup', null)
        d3.select(window).on('blur', null).on('copy', null).on('paste', null).on('cut', null)
    }

    componentDidUpdate() {
        // this.nodebookContent.focus()
        // this.updateRanks()
    }

    attachListeners = () => {
        // Leave this in as well because of reasons
        this.ctxMenuNode
            .on('contextmenu', () => {
                d3.event.preventDefault()
                d3.event.stopPropagation()
            })

        this.ctxMenuSvg
            .on('contextmenu', () => {
                d3.event.preventDefault()
                d3.event.stopPropagation()
            })

        // Leave this one in for now to not check for copy/paste/cut key combinations in the ordinary event listeners
        //document.addEventListener('copy', (e)=>{
        d3.select(window).on('copy', () => {
            if (this._isShareView !== true && this.nodebookComponentFocus) {
                d3.event.preventDefault();
                this.cmdCopyNodes(d3.event)
            }
            this._isShareView = false
        })

        //document.addEventListener('paste', (e)=>{
        d3.select(window).on('paste', () => {
            if (this.nodebookComponentFocus) {
                let pasteNodes = (d3.event.clipboardData || window.clipboardData).getData('nodebook/nodes');
                let pasteText = (d3.event.clipboardData || window.clipboardData).getData('text');
                if (pasteNodes !== "") {
                    this.cmdPasteNodes(false, true, pasteNodes)
                } else {
                    this.cmdPasteNodes(false, false, pasteText)
                }

            }
        })

        //document.addEventListener('cut', (e)=>{
        d3.select(window).on('cut', () => {
            if (this.nodebookComponentFocus) {
                d3.event.preventDefault();
                this.cmdCutNodes(d3.event)
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.id !== nextProps.match.params.id) {
            this.componentWillUnmount();
            this.props = nextProps;
            this.componentWillMount();
            this.attachListeners();

        } else {
            this.props = nextProps;
        }
        this.retransformUponParams()
    }

    nodebookComponentKeyDown = (event) => {
        this.keyPressDict.shift = event.shiftKey
        this.keyPressDict.ctrl = (event.keyCode === 17 || event.keyCode === 91)
        this.keyPressDict.alt = event.altKey

        this.keyPressDict.link = this.keyPressDict.link || this.keyPressDict.alt

        // Ctrl + A = select all
        if (event.ctrlKey && event.keyCode === 65) {
            event.preventDefault()
            event.stopPropagation()
            this.selectMultipleNodes(this.state.nodesData)
        }
        // Ctrl + D = deselct all
        if (event.ctrlKey && event.keyCode === 68) {
            event.preventDefault()
            event.stopPropagation()
            this.selectNode()
        }
    }

    nodebookComponentKeyUp = (event) => {
        this.keyPressDict.shift = event.shiftKey
        if (event.keyCode === 17 || event.keyCode === 91) {
            this.keyPressDict.ctrl = false
        }
        this.keyPressDict.alt = event.altKey

        this.keyPressDict.link = this.keyPressDict.alt

        // delete button
        if (46 === event.keyCode) {
            this.hideCtxMenus()
            this.selectionDeleteAll()
        }
        // F button
        if (70 === event.keyCode) {
            this.transformToSelection()
        }
        // R button
        if (82 === event.keyCode) {
            this.transformToSelection(true)
        }

        // H button
        if (72 === event.keyCode) {
            this.toggleHeatmap()
        }
    }

    // nodebookComponentOnCopy = () => {
    //     console.log('copy capture')
    //     //this.cmdCopyNodes()
    // }

    // nodebookComponentOnPaste = () => {
    //     console.log('paste capture')
    //     //this.cmdPasteNodes()
    // }

    // nodebookComponentOnCut = () => {
    //     console.log('cut capture')
    //     //this.cmdCutNodes()
    // }

    nodebookComponentOnBlur = (event) => {
        //console.log('blur;')
        this.nodebookComponentFocus = false;
        this.keyPressDict.shift = false
        this.keyPressDict.ctrl = false
        this.keyPressDict.alt = false
        this.keyPressDict.link = false
    }

    nodebookComponentOnFocus = (event) => {
        this.nodebookComponentFocus = true;
    }

    componentDidMount() {
        this.attachListeners();
        var oldCoordSidebar = null
        var oldCoordDetails = null
        var handleSidebar = this.nodebookHandle
        var handleDetails = this.nodebookDetailsHandle
        var sidebar = this.nodebookSidebarWrap
        var details = this.nodebookDetailsWrap
        var content = this.nodebookContent
        var ndbkCmp = this.nodebookComponent

        this._sd_move = {
            s: false,
            d: false
        }

        var self = this

        if (handleSidebar) {
            handleSidebar.addEventListener('mousedown', startSidebar)
        }

        if (handleDetails) {
            handleDetails.addEventListener('mousedown', startDetails)
        }

        // Sidebar cookie code
        let sidebarCookie = localStorage.getItem('sidebar');
        if (sidebarCookie !== 'show') {
            this.sidebarHide()
        }

        // Sidebar-width cookie code
        let sidebarCookieWidth = localStorage.getItem('sidebar-width');
        if (sidebarCookieWidth) {
            sidebar.style.width = sidebarCookieWidth + 'px'
        }

        // Details cookie code
        let detailsCookie = localStorage.getItem('details');
        if (detailsCookie === 'hide') {
            this.detailsHide()
        }

        // Details-width cookie code
        let detailsCookieWidth = localStorage.getItem('details-width');
        if (sidebarCookieWidth) {
            details.style.width = detailsCookieWidth + 'px'
        }

        // Content width offset
        let contentCookieWidth = localStorage.getItem('content-width');
        if (contentCookieWidth) {
            content.style.width = contentCookieWidth
            ndbkCmp.resizeHandler()
        }

        function stopSidebar() {
            window.removeEventListener('mouseup', stopSidebar)
            window.removeEventListener('mousemove', moveSidebar)
            document.body.style.cursor = 'auto'
            content.style.pointerEvents = 'auto'
        }

        function moveSidebar(e) {
            self._sd_move.s = true
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            e.cancelBubble = true;
            e.returnValue = false;
            var newCoordSidebar = e.screenX
            var offsetSidebar = newCoordSidebar - oldCoordSidebar
            oldCoordSidebar = newCoordSidebar
            var newWidthSidebar = sidebar.offsetWidth + offsetSidebar
            var nodebookWidth = content.offsetWidth - offsetSidebar
            //var nodebookHeight = content.offsetHeight
            sidebar.style.width = newWidthSidebar + 'px'
            localStorage.setItem('content-width', content.offsetWidth - offsetSidebar)
            content.style.width = content.offsetWidth - offsetSidebar + 'px'
            localStorage.setItem('sidebar-width', newWidthSidebar)
            // ndbkCmp.translateABit(offsetSidebar, 0)
            ndbkCmp.resizeHandler()

        }

        function startSidebar(e) {
            self._sd_move.s = false
            content.style.pointerEvents = 'none'
            window.addEventListener('mouseup', stopSidebar)
            oldCoordSidebar = e.screenX
            window.addEventListener('mousemove', moveSidebar)
        }

        function stopDetails() {
            window.removeEventListener('mouseup', stopDetails)
            window.removeEventListener('mousemove', moveDetails)
            document.body.style.cursor = 'auto'
            content.style.pointerEvents = 'auto'
        }

        function moveDetails(e) {
            self._sd_move.d = true
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            e.cancelBubble = true;
            e.returnValue = false;
            var newCoordDetails = e.screenX
            var offsetDetails = oldCoordDetails - newCoordDetails
            oldCoordDetails = newCoordDetails
            var newWidthDetails = details.offsetWidth + offsetDetails
            var nodebookWidth = content.offsetWidth - offsetDetails
            details.style.width = newWidthDetails + 'px'
            localStorage.setItem('content-width', content.offsetWidth - offsetDetails)
            content.style.width = content.offsetWidth - offsetDetails + 'px'
            localStorage.setItem('details-width', newWidthDetails)

            ndbkCmp.resizeHandler()
        }

        function startDetails(e) {
            self._sd_move.d = false
            content.style.pointerEvents = 'none'
            window.addEventListener('mouseup', stopDetails)
            oldCoordDetails = e.screenX
            window.addEventListener('mousemove', moveDetails)
        }

        d3.select("body").selectAll(".btnmenu")
            .on('click', function () {
                if (!this._s) {
                    this._s = 'none'
                }
                d3.select(this).select(".menu").style('display', this._s = (this._s == 'none' ? 'inline-block' : 'none'))
            })

        this.nodebookContent.focus()
    }

    transformToSelection = (includeAll = false) => {
        // Different enough from transformUponParams to be a separate function, leave for now and consolidate later if necessary
        if (this.state.selection.nodes.length === 0 && this.state.selection.links.length === 0 && !includeAll) {
            return
        }

        var bbox = {
            x1: null, y1: null,
            x2: null, y2: null
        }
        let ndbkCmp = this.nodebookComponent
        let w = ndbkCmp.containerWidth
        let h = ndbkCmp.containerHeight
        let modifierX = w / 2;
        let modifierY = h / 2;

        var totalNodes = 0
        if (includeAll) {
            this.state.nodesData.forEach(
                (node, id) => {
                    if (id === 0) {
                        bbox.x1 = node.x
                        bbox.x2 = node.x
                        bbox.y1 = node.y
                        bbox.y2 = node.y
                    } else {
                        if (node.x < bbox.x1) bbox.x1 = node.x
                        if (node.x > bbox.x2) bbox.x2 = node.x
                        if (node.y < bbox.y1) bbox.y1 = node.y
                        if (node.y > bbox.y2) bbox.y2 = node.y
                    }
                    totalNodes++
                    //this.selectNode(node)
                }
            )
        } else {
            let focusedNodes = this.state.selection.nodes.slice()
            this.state.selection.links.forEach(linkId => {
                var link = this.state.linksData[this.state.linksHashTable[linkId]]
                focusedNodes.push(link.from_id)
                focusedNodes.push(link.to_id)
            })
            focusedNodes.forEach(
                (nodeId, id) => {
                    var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                    if (id === 0) {
                        bbox.x1 = node.x
                        bbox.x2 = node.x
                        bbox.y1 = node.y
                        bbox.y2 = node.y
                    } else {
                        if (node.x < bbox.x1) bbox.x1 = node.x
                        if (node.x > bbox.x2) bbox.x2 = node.x
                        if (node.y < bbox.y1) bbox.y1 = node.y
                        if (node.y > bbox.y2) bbox.y2 = node.y
                    }
                    //this.selectNode(node)
                    totalNodes++
                }
            )
        }

        if (totalNodes === 1) {
            var k = 1.0
            // 75 slightly adjusts off-center
            var x = (modifierX - bbox.x1)//- 75)
            var y = (modifierY - bbox.y1 - 75)
        } else {
            let modifier = 200
            bbox.x1 -= modifier
            bbox.x2 += modifier
            bbox.y1 -= modifier
            bbox.y2 += modifier
            var bbox_w = bbox.x2 - bbox.x1
            var bbox_h = bbox.y2 - bbox.y1
            var kx = w / bbox_w
            var ky = h / bbox_h
            k = (kx < ky ? kx : ky) // TODO check
            k = k > 1 ? 1 : k
            x = (modifierX - (bbox.x1 + bbox.x2) * 0.5 * k)
            y = (modifierY - (bbox.y1 + bbox.y2) * 0.5 * k)
        }
        ndbkCmp.transformTo(x, y, k)
    }

    retransformUponParams = () => {
        let paramsString = this.props.match.params.transformations
        let transParams = new URLSearchParams(paramsString)
        let x = transParams.get('x')
        let y = transParams.get('y')
        let k = transParams.get('k')
        let nodeIdsString = transParams.get('ids')
        if ((x !== null && y !== null) || (nodeIdsString !== null)) {

            let nodeIds = (nodeIdsString) ? nodeIdsString.split(',').map(value => parseInt(value, 10)) : []
            var bbox = {
                x1: null, y1: null,
                x2: null, y2: null
            }
            var nodesToBeSelected = []
            let ndbkCmp = this.nodebookComponent
            let w = ndbkCmp.containerWidth
            let h = ndbkCmp.containerHeight
            let modifierX = w / 2;
            let modifierY = h / 2;
            nodeIds.forEach(
                (nodeId, id) => {
                    var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                    if (id === 0) {
                        bbox.x1 = node.x
                        bbox.x2 = node.x
                        bbox.y1 = node.y
                        bbox.y2 = node.y
                    } else {
                        if (node.x < bbox.x1) bbox.x1 = node.x
                        if (node.x > bbox.x2) bbox.x2 = node.x
                        if (node.y < bbox.y1) bbox.y1 = node.y
                        if (node.y > bbox.y2) bbox.y2 = node.y
                    }
                    nodesToBeSelected.push(node)
                }
            )
            this.selectMultipleNodes(nodesToBeSelected)
            if (!x && !y && !k) {
                if (nodeIds.length === 1) {
                    k = 1.0
                    // 75 slightly adjusts off-center
                    x = (modifierX - bbox.x1 - 75)
                    y = (modifierY - bbox.y1 - 75)
                } else {
                    let modifier = 200
                    bbox.x1 -= modifier
                    bbox.x2 += modifier
                    bbox.y1 -= modifier
                    bbox.y2 += modifier
                    var bbox_w = bbox.x2 - bbox.x1
                    var bbox_h = bbox.y2 - bbox.y1
                    var kx = w / bbox_w
                    var ky = h / bbox_h
                    k = (kx < ky ? kx : ky) // TODO check
                    k = k > 1 ? 1 : k
                    x = (modifierX - (bbox.x1 + bbox.x2) * 0.5 * k)
                    y = (modifierY - (bbox.y1 + bbox.y2) * 0.5 * k)
                }
            }
            x = x || 0
            y = y || 0
            k = k || 1
            ndbkCmp.transformTo(x, y, k)
        }
    }

    sidebarHide = (e = null, forceShow = false) => {
        if (this._sd_move.s) {
            return
        }
        // hide sidebar
        var sidebar = this.nodebookSidebarWrap
        if (sidebar.style.display === "none" || forceShow) {
            localStorage.setItem('sidebar', 'show')
            sidebar.style.display = ''
            this.sidebarHideButton.innerHTML = '〈'
        } else {
            localStorage.setItem('sidebar', 'hide')
            sidebar.style.display = 'none'
            this.sidebarHideButton.innerHTML = '〉'
        }
        // resize svg
        this.nodebookComponent.resizeHandler()
    }

    detailsHide = () => {
        if (this._sd_move.d) {
            return
        }
        // hide details
        var details = this.nodebookDetailsWrap
        if (details.style.display === "none") {
            localStorage.setItem('details', 'show')
            details.style.display = ''
            this.detailsHideButton.innerHTML = '〉'
        } else {
            localStorage.setItem('details', 'hide')
            details.style.display = 'none'
            this.detailsHideButton.innerHTML = '〈'
        }
        // resize svg
        this.nodebookComponent.resizeHandler()
    }

    buildDataStructures = () => {
        if (this.state.isCompare) {
            this.buildCompareDataStructures()
        } else {
            this.buildNonCompareDataStructures()
        }
    }

    buildNonCompareDataStructures = () => {

        if (!(this.loaded.nodes && this.loaded.links)) {
            return
        }

        // console.log("%c Building data structures", 'color: red')

        var ni, li, node;

        // nodes
        for (ni = 0; ni < this.loaded.nodes.length; ni++) {
            node = this.loaded.nodes[ni]
            // stavi svakom node-u da ima listu njegovih linkova
            node.linksList = []
            // stavi svakom node-u da ima selected shit
            node._selectionId = -1
            node._cullPassed = false
            // stavi node u hashtable
            this.state.nodesHashTable[node.id] = ni
        }

        // links
        for (li = 0; li < this.loaded.links.length; li++) {
            var link = this.loaded.links[li]
            // stavi link u hashtable
            this.state.linksHashTable[link.id] = li
            // stavi svakom linku selection id
            link._selectionId = -1
            link._cullPassed = false
            // nakaci link podatke na 'from' node
            var from_node = this.loaded.nodes[this.state.nodesHashTable[link.from_id]]
            var to_node = this.loaded.nodes[this.state.nodesHashTable[link.to_id]]
            if (!from_node || !to_node) {
                continue
            }
            link.x1 = from_node.x
            link.y1 = from_node.y
            from_node.linksList.push(link.id)
            // nakaci link podatke na 'to' node
            link.x2 = to_node.x
            link.y2 = to_node.y
            to_node.linksList.push(link.id)
        }

        this.setState({
            nodesData: this.loaded.nodes,
            linksData: this.loaded.links,
            nodesHashTable: this.state.nodesHashTable,
            linksHashTable: this.state.linksHashTable,
        }, () => {
            // this.updateRanks()
            let transformation = null
            try {
                transformation = JSON.parse(localStorage.getItem(`ndbk${this.props.match.params.id}_transformations`))
            } catch (err) {
                transformation = null
            }
            if (transformation === null && !this.props.match.params.transformations) {
                this.transformToSelection(true)
            } else {
                this.retransformUponParams()
            }

            this.nodebookComponent.dataChangeHandler({
                created: this.state.nodesData,
                deleted: []
            })

            // Only need this function to trigger a end event on zoom, will check for alternatives
            this.nodebookComponent.cullNodes()
            // Only need this function to trigger a end event on zoom, will check for alternatives
            //            this.setState({renderLinks: false, renderNodes: true})
            this.loaded = {
                nodes: null,
                links: null,
            }
        })
    }

    buildCompareDataStructures = () => {
        if (!(
            this.loaded.nodes &&
            this.loaded.links &&
            this.loaded.cloneNodes &&
            this.loaded.cloneLinks
        )) {
            return
        }

        // console.log("%c Building compare data structures", 'color: blue')

        // all loaded and good, ready to build data structures now
        var nodes = null
        var links = null
        var nodeHashes = {}
        var linkHashes = {}
        //var templates = {}


        var ni, li, node;

        nodes = this.loaded.nodes
        links = this.loaded.links

        // nodes
        console.log("%c --Nodes", 'color: blue')
        for (ni = 0; ni < this.loaded.nodes.length; ni++) {
            node = this.loaded.nodes[ni]
            // stavi svakom node-u da ima listu njegovih linkova
            node.linksList = []
            // stavi svakom node-u da ima selected shit
            node._selectionId = -1
            node._cullPassed = true
            // #compare
            node._compareType = 'red'
            // stavi node u hashtable
            this.state.nodesHashTable[node.id.toString()] = ni
            // zapamti hash
            nodeHashes[node.node_hash] = ni
        }

        // links
        console.log("%c --Links", 'color: blue')
        for (li = 0; li < links.length; li++) {
            var link = links[li]
            // stavi svakom linku selection id
            link._selectionId = -1
            link._cullPassed = true
            // #compare
            link._compareType = 'red'
            // ubaci hash
            linkHashes[link.link_hash] = li
            // stavi link u hashtable
            this.state.linksHashTable[link.id] = li

            var from_node = nodes[this.state.nodesHashTable[link.from_id]]
            var to_node = nodes[this.state.nodesHashTable[link.to_id]]
            if (!from_node || !to_node) {
                continue
            }

            // nakaci link podatke na 'from' node
            link.x1 = from_node.x
            link.y1 = from_node.y
            from_node.linksList.push(link.id)
            // nakaci link podatke na 'to' node
            link.x2 = to_node.x
            link.y2 = to_node.y
            to_node.linksList.push(link.id)
        }

        // ---------------------------------------------------------------------

        var cloneHashes = {}

        // cloned nodes
        console.log("%c --Nodes (cloned)", 'color: blue')
        for (ni = 0; ni < this.loaded.cloneNodes.length; ni++) {
            node = this.loaded.cloneNodes[ni]

            // this is useful for links retreival linked to the cloned nodes
            cloneHashes[node.id] = node.node_hash

            // check if base branch has this node
            var nodeIsInBase = (nodeHashes[node.node_hash] !== undefined)

            if (!nodeIsInBase) {
                // do sada nije postojao, ovo je izmena, i to negativna
                // stavi svakom node-u da ima listu njegovih linkova
                node.linksList = []
                // stavi svakom node-u da ima selected shit
                node._selectionId = -1
                node._cullPassed = true
                // #compare
                node._compareType = 'green'
                // gurni ga u listu
                nodes.push(node)
                // stavi node u hashtable
                this.state.nodesHashTable[node.id] = nodes.length - 1
                // zapamti hash
                nodeHashes[node.node_hash] = nodes.length - 1
            } else {
                // ovaj node se nalazi se u oba
                var isChanged = false
                var baseNode = nodes[nodeHashes[node.node_hash]]
                baseNode._diff = {}
                if (baseNode.properties.templateId !== node.properties.templateId) {
                    isChanged = true
                } else {
                    // isti templejt, a polja?
                    this.state.templatesData[node.properties.templateId].fields.forEach(
                        field => {
                            if ('array' === field.type || 'files' === field.type || 'url' === field.type) {
                                var diff = {
                                    base: [],
                                    both: [],
                                    clone: []
                                }
                                var ar = node.properties[field.name]
                                var baseAr = baseNode.properties[field.name]
                                var both = [...ar, ...baseAr]
                                if ('files' === field.type) {
                                    ar = ar.map(f => `${f.name} (${f.url})`)
                                    baseAr = baseAr.map(f => `${f.name} (${f.url})`)
                                    both = both.map(f => `${f.name} (${f.url})`)
                                } else if ('url' === field.type) {
                                    ar = ar.map(u => `${u.title} (${u.href})`)
                                    baseAr = baseAr.map(u => `${u.title} (${u.href})`)
                                    both = both.map(u => `${u.title} (${u.href})`)
                                }
                                both.forEach(
                                    item => {
                                        if (ar.indexOf(item) !== -1 && baseAr.indexOf(item) !== -1) {
                                            // both array have the item
                                            if (diff.both.indexOf(item) === -1)
                                                diff.both.push(item)
                                        }
                                        else if (ar.indexOf(item) === -1 && baseAr.indexOf(item) !== -1) {
                                            // only base has the item
                                            if (diff.base.indexOf(item) === -1)
                                                diff.base.push(item)
                                            isChanged = true
                                        }
                                        else if (ar.indexOf(item) !== -1 && baseAr.indexOf(item) === -1) {
                                            // only clone has the item
                                            if (diff.clone.indexOf(item) === -1)
                                                diff.clone.push(item)
                                            isChanged = true
                                        }
                                        // if (ar.indexOf(item)==-1 || baseAr.indexOf(item)==-1 ) {
                                        //     isChanged = true
                                        // }
                                    }
                                )
                                if (diff.base.length > 0 || diff.clone.length > 0) {
                                    // there was a difference, so store it
                                    baseNode._diff[field.name] = diff
                                }
                            } else if ('ref' === field.type || 'color' === field.type || 'idsgroup' === field.type || 'likes' === field.type || 'layout' === field.type || '_render' === field.type) {
                                // no-op
                            } else /*if ('text'===field.type || 'textarea'===field.type || 'linktype'===field.type)*/ {
                                if (baseNode.properties[field.name].toString() !== node.properties[field.name].toString()) {
                                    isChanged = true
                                    // record change
                                    baseNode._diff[field.name] = {
                                        base: baseNode.properties[field.name],
                                        clone: node.properties[field.name]
                                    }
                                }
                            }
                            // 'color' and 'ref' types are not handled
                        }
                    )
                }

                // do sada znamo da li je bilo sta promenjeno u vezi ova dva noda
                if (isChanged) {
                    baseNode._compareType = 'yellow'
                } else {
                    baseNode._compareType = 'none'
                }
            }
        }

        // cloned links
        console.log("%c --Links (cloned)", 'color: blue')
        for (li = 0; li < this.loaded.cloneLinks.length; li++) {
            link = this.loaded.cloneLinks[li]

            // check if base branch has this link
            var linkIsInBase = (linkHashes[link.link_hash] !== undefined)

            if (!linkIsInBase) {

                // stavi svakom linku selection id
                link._selectionId = -1
                // #compare
                link._compareType = 'green'
                // dodaj link
                links.push(link)
                // ubaci hash
                // linkHashes[link.link_hash] = links.length-1
                // stavi link u hashtable
                this.state.linksHashTable[link.id] = links.length - 1
                // nakaci link podatke na 'from' node
                var from_node = nodes[nodeHashes[cloneHashes[link.from_id]]]
                link.x1 = from_node.x
                link.y1 = from_node.y
                from_node.linksList.push(link.id)
                link.from_id = from_node.id     // re-bind
                // nakaci link podatke na 'to' node
                var to_node = nodes[nodeHashes[cloneHashes[link.to_id]]]
                link.x2 = to_node.x
                link.y2 = to_node.y
                to_node.linksList.push(link.id)
                link.to_id = to_node.id // re-bind
            } else {
                // ovaj link se nalazi se u oba
                var isChanged = false
                var baseLink = links[linkHashes[link.link_hash]]
                baseLink._diff = {}

                // iste li su informacije
                var props = TemplatesLib[4].fields.map(value => value.name)
                props.forEach(
                    prop => {
                        if (baseLink.properties[prop] !== link.properties[prop]) {
                            isChanged = true
                            // record change
                            baseLink._diff[prop] = {
                                base: baseLink.properties[prop],
                                clone: link.properties[prop]
                            }
                        }
                    }
                )

                // do sada znamo da li je bilo sta promenjeno u vezi ova dva linka
                if (isChanged) {
                    baseLink._compareType = 'yellow'
                } else {
                    baseLink._compareType = 'none'
                }
            }
        }

        this.setState({
            nodesData: nodes,
            linksData: links,
            nodesHashTable: this.state.nodesHashTable,
            linksHashTable: this.state.linksHashTable,
        }, () => {
            // this.updateRanks()
            this.nodebookComponent.dataChangeHandler({
                created: this.state.nodesData,
                deleted: []
            })
            this.loaded = {
                nodes: null,
                links: null,
                cloneNodes: null,
                cloneLinks: null,
            }
        })
    }

    // create nodes from pdfData
    makeNodesFromData = (createNodesData) => {
        if (createNodesData.length === 0) {
            return
        }

        let createNodesProperties = []

        let updateNodeIds = []
        let updateNodeProperties = []

        createNodesData.forEach((newNode, newIndex) => {
            let hasFound = false;
            this.state.nodesData.forEach((node, index) => {
                if ((node.properties.fileName !== undefined) && (node.properties.fileName === newNode.fileName)) {
                    updateNodeIds.push(node.id)
                    let oldProps = {
                        file: node.properties.file,
                        x: node.x,
                        y: node.y,
                        width: node.width,
                        height: node.height
                    }
                    updateNodeProperties.push({ ...node.properties, ...newNode.properties, ...oldProps })
                    hasFound = true
                }
            })
            if (!hasFound) {
                createNodesProperties.push(newNode)
            }
        })

        var NumberOfFiles = createNodesProperties.length;
        var { x, y } = this.getMiddle()
        let squareSide = Math.ceil(Math.sqrt(NumberOfFiles))
        let topSide = Math.round(squareSide * 2 / 3)
        let height = 90;
        let width = 200;
        x = x - squareSide * width / 2
        y = y - squareSide * height / 2

        this.createNodes(createNodesProperties.map(
            (value, index) => ({
                properties: {
                    ...value.properties,
                    height: height,
                    width: width,
                    x: (x + (index % topSide) * (width + 10)),
                    y: (y + (Math.floor(index / topSide)) * (height + 10)),
                    templateId: 10
                },
            })
        ), null, false, true)

        updateNodeProperties.forEach(value => {
            value = this.setDefaults(value)
        })

        this.selectionUpdateAll(updateNodeProperties, { nodes: updateNodeIds, links: [] })
    }

    compareNodebooks = () => {
        this.props.history.push(`/nodebook/${this.props.match.params.id}/compare/${this.state.compareBranch}`)
        //krc
    }
    //endregion
    //---------------------------------------------------------

    getShareTokenFromParams = () => {
        let paramsString = this.props.match.params.transformations
        let token = undefined
        if (paramsString) {
            var params = new URLSearchParams(paramsString)
            token = params.get('token')
        }
        return token
    }

    isEmbed = () => {
        const urlParams = this.props.location.search.replace('?', '').split('&')
        const hasEmbedParam = urlParams.reduce((prev, curr) => {
            return prev || (curr === "embed")
        }, false)
        return hasEmbedParam
    }

    isNoBackground = () => {
        const urlParams = this.props.location.search.replace('?', '').split('&')
        const hasEmbedParam = urlParams.reduce((prev, curr) => {
            return prev || (curr === "noBackground")
        }, false)
        return hasEmbedParam
    }

    //region REQUESTS
    requestNodebookInfoData = (ndbkId = this.props.match.params.id) => {

        // console.log("%c Nodebook info requested.", 'color: #bbb')
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${ndbkId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                shareToken: this.getShareTokenFromParams()
            }),
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                // console.log("%c Nodebook info arrived:", 'color: #bbb', response);
                if (response.success) {

                    const isEmbed = this.isEmbed()

                    if (ndbkId === this.props.match.params.id) {
                        this.originalNodebookTitle = response.data.title
                        // general info
                        this.setState({
                            nodebookInfo: {
                                ...response.data,
                                canEdit: isEmbed ? false : ((response.data.permissions === 'edit' || response.data.permissions === 'admin') ? true : false)
                            }
                        })
                    } else {
                        this.clonedNodebookTitle = response.data.title
                    }
                    // title
                    document.title = `${this.originalNodebookTitle} ${this.clonedNodebookTitle ? ` | ${this.clonedNodebookTitle}` : ''}  - ${constants.WEBSITE_TITLE}`
                } else {
                    this.setState({ errCode: response.code })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    setDefaults = (properties) => {
        // position
        if (!properties.x || !properties.y) {
            var center = this.getMiddle()
            properties.x = center.x
            properties.y = center.y
        }
        // width & height (disregarding template type, because why not)
        properties.width = properties.width || 200
        properties.height = properties.height || 90
        // props
        let templateId = properties.templateId
        if (properties._render === undefined) {
            properties._render = {}
        }
        this.state.templatesData[templateId].fields.forEach(
            field => {

                if (undefined === properties[field.name]) {
                    // if (field.default===undefined)
                    //     console.log(field, templateId)
                    // else
                    properties[field.name] = field.default.val
                }

                if (field.hasRender) {
                    // if (field.default===undefined)
                    //     console.log(field, templateId)
                    // else
                    properties._render[field.name] = {
                        ...field.default.render,
                        ...properties._render[field.name]
                    }
                }

                // if ('array'!==field.type && undefined === properties[field.name]) {
                //     if (field.name==='color') {
                //         properties[field.name] = (templateId===0?'#888':(templateId===1?'#444':'white'))
                //     } else if ('layout'===field.name) {
                //         properties[field.name] = 6
                //     } else if ('_render'===field.name) {
                //         properties[field.name] = {}
                //     } else {
                //         properties[field.name] = ``
                //     }
                // }
                // if ('array'===field.type) {
                //     if (undefined !== properties[field.name]) {
                //         if (typeof properties[field.name] === 'string' || properties[field.name] instanceof String) {
                //             properties[field.name] = properties[field.name].split(new RegExp(/ and |\s*;\s*/, 'i'))
                //         }
                //     } else {
                //         properties[field.name] = []
                //     }
                // }
                // if ('files'===field.type && !Array.isArray(properties[field.name])) {
                //     properties[field.name]=[]
                // }
            }
        )

        return properties
    }

    requestNodesData = (ndbkId = this.props.match.params.id) => {

        // console.log("%c Nodes requested.", 'color: #bbb')
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${ndbkId}/nodes`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                shareToken: this.getShareTokenFromParams()
            }),
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                // console.log("%c Nodes arrived:", 'color: #bbb', response);
                if (response.success) {
                    response.data.forEach(
                        node => {
                            let correctProperties = this.setDefaults(node.properties)
                            const { x, y, width, height, settings, ...rest } = correctProperties
                            node.properties = rest
                            node.x = x
                            node.y = y
                            node.width = width
                            node.height = height
                        }
                    )
                    if (ndbkId === this.props.match.params.id) {
                        this.loaded.nodes = response.data
                    } else {
                        this.loaded.cloneNodes = response.data
                    }

                    this.buildDataStructures()
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    requestCloningData = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/branches`, {
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                // console.log("%c Cloning data arrived:", 'color: #bbb', response)
                if (response.success) {
                    response.data.clones.sort((a, b) => {
                        if (a.date_created < b.date_created) return 1
                        if (a.date_created > b.date_created) return -1
                        return 0
                    })
                    this.setState({ branchesData: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    publishNodebook = (cb) => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/publish`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if (cb) {
                        cb()
                    }
                }
                return response.success
            })
            .catch((error) => {
                console.error(error);
            });
    }

    requestMerge = (parent) => {
        fetch(`https://${constants.SERVER_IP}/api/request-merge/${this.props.match.params.id}/with/${parent}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    // TODO notify user of the success
                } else {
                    // TODO notify user of the failure
                }
                return response.success
            })
            .catch((error) => {
                console.error(error);
            });
    }

    cloneNodebook = (cb) => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/clone`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.requestCloningData()
                    if (cb) {
                        cb(response.data.id)
                    }
                }
                return response.success
            })
            .catch((error) => {
                console.error(error);
            });
    }

    onNodeFileInput = (file, id, cb) => {
        const reader = new FileReader();
        reader.onload = () => {
            //const fileAsBinaryString = reader.result;
            var formData = new FormData();
            formData.append('file', file)
            //fetch(`https://${constants.SERVER_IP}/api/node/${id}/upload`, {
            fetch(`https://${constants.SERVER_IP}/api/file/upload`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        cb(response.data)
                    }
                    return response.success
                })
                .catch((err) => {
                })
        };
        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        try {
            reader.readAsBinaryString(file);
        } catch (err) {
            console.log(err)
        }
    }

    onFileInput = (files) => {
        var file = files[0]
        const reader = new FileReader();
        reader.onload = () => {
            //const fileAsBinaryString = reader.result;
            var formData = new FormData();
            formData.append('profile_image', file)
            fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/upload_nodebook_profile_picture`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        this.setState({
                            nodebookInfo: { ...this.state.nodebookInfo, avatar: response.data.url }
                        })
                    }
                })
                .catch((err) => {
                })
        };
        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        try {
            reader.readAsBinaryString(file);
        } catch (err) {
            console.log(err)
        }
    }

    likeNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/like`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ nodebookInfo: { ...this.state.nodebookInfo, isLiked: true } })
                }
            })
    }

    unlikeNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/unlike`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ nodebookInfo: { ...this.state.nodebookInfo, isLiked: false } })
                }
            })
    }

    subscribeNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/subscribe`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ nodebookInfo: { ...this.state.nodebookInfo, isFollowing: true } })
                }
            })
    }

    unsubscribeNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/unsubscribe`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ nodebookInfo: { ...this.state.nodebookInfo, isFollowing: false } })
                }
            })
    }

    updateNodebook = (props) => {
        var oldInfo = { ...this.state.nodebookInfo }
        var newInfo = { ...this.state.nodebookInfo, ...props }
        document.title = newInfo.title + ' - ' + constants.WEBSITE_TITLE
        this.setState({ nodebookInfo: newInfo })
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/update`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                title: newInfo.title,
                description: newInfo.description,
                visibility: newInfo.visibility
            })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.success) {
                    this.setState({ nodebookInfo: oldInfo })
                    document.title = oldInfo.title + ' - ' + constants.WEBSITE_TITLE
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    deleteNodebook = (cb) => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/delete`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if (cb) {
                        cb()
                    }
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    toggleVisibility = () => {
        this.setState({
            nodebookInfo: { ...this.state.nodebookInfo, visibility: (this.state.nodebookInfo.visibility === 'public' ? 'private' : 'public') }
        }, this.updateNodebook)
    }

    requestLinksData = (ndbkId = this.props.match.params.id) => {

        // console.log("%c Links requested.", 'color: #bbb')
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${ndbkId}/links`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                shareToken: this.getShareTokenFromParams()
            }),
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                // console.log("%c Links arrived:",'color: #bbb', response);
                if (response.success) {
                    response.data.forEach(link => link.description = (!link.description ? '' : link.description))
                    if (ndbkId === this.props.match.params.id) {
                        this.loaded.links = response.data
                    } else {
                        this.loaded.cloneLinks = response.data
                    }
                    // this.loaded.links = response.data
                    this.buildDataStructures()
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchMetaData(url, props) {
        fetch(`https://${constants.SERVER_IP}/api/fetch-meta-data`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ url: url })
            //example url:'http://nodebook.io/nodebook/534'
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.createNodes([{
                        properties: {
                            x: props.x,
                            y: props.y,
                            image: response.data.ogImage.url,
                            title: response.data.ogTitle,
                            url: [{ title: response.data.ogUrl, href: response.data.ogUrl }],
                            description: response.data.ogDescription,
                            _render: {
                                // authors: {
                                //     ...TemplatesLib[12].fields.filter(f=>f.name==='authors')[0].default.render,
                                //     display: false
                                // },
                                tags: {
                                    ...TemplatesLib[12].fields.filter(f => f.name === 'tags')[0].default.render,
                                    display: false
                                },
                                description: {
                                    ...TemplatesLib[12].fields.filter(f => f.name === 'description')[0].default.render,
                                    display: true
                                },
                            },
                            //x: this.ctxMenuData.position.x,
                            //y: this.ctxMenuData.position.y,
                            templateId: 12
                        },
                    }])
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    //endregion
    //---------------------------------------------------------

    getSelection = () => {
        return this.state.selection
    }
    createNodes = (data, cb = null, skipCreate = false, transformPostCreate = false, uploadLater = false) => {

        // settign default properties if not present
        data = data.map((value, index) => {
            let properties = this.setDefaults(value.properties)
            return ({ ...value, properties, index: index })
        })

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/nodes/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: data }),
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    var madeNodes = []
                    var madeNodesForEmit = []
                    response.data.forEach(value => {
                        let index = value.index
                        let id = value.id
                        let { x, y, width, height, ...rest } = data[index].properties
                        let fileHash = data[index].fileHash
                        if (uploadLater) rest.color = '#d8d8d8'
                        let node = {
                            id: id,
                            properties: rest,
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            _selectionId: -1,
                            _cullPassed: true,
                            linksList: [],
                            fileHash: fileHash,
                        }

                        madeNodes.push(node)

                        madeNodesForEmit.push({
                            id: id,
                            properties: rest,
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            _selectionId: -1,
                            linksList: [],
                            fileHash: fileHash,
                        })

                        if (!skipCreate) {
                            this.state.nodesHashTable[node.id] = this.state.nodesData.length
                            this.state.nodesData.push(node)
                        }
                    })

                    this.nodebookComponent.dataChangeHandler({
                        created: madeNodes,
                        deleted: []
                    })

                    this.setState({
                        nodesData: this.state.nodesData,
                    }, () => {
                        if (cb) {
                            cb(madeNodes)
                        } else {
                            if (!skipCreate) {
                                this.selectMultipleNodes(madeNodes)
                                if (transformPostCreate) {
                                    this.transformToSelection()
                                }
                            }
                        }
                    })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    canCreateLink = (targetNode) => {
        var canCreateLinkAll = false
        this.state.selection.nodes.forEach(
            sNodeIdx => {
                var srcNode = this.state.nodesData[this.state.nodesHashTable[sNodeIdx]]

                var link = {
                    from_id: srcNode.id,
                    to_id: targetNode.id,
                    _selectionId: -1,
                    _cullPassed: true,
                }

                var canCreateLink = true
                canCreateLink = (link.from_id !== link.to_id)
                srcNode.linksList.forEach(
                    linkId => {
                        var _link = this.state.linksData[this.state.linksHashTable[linkId]]
                        if ((_link.from_id === srcNode.id && _link.to_id === targetNode.id) ||
                            (_link.from_id === targetNode.id && _link.to_id === srcNode.id)
                        ) {
                            // link between these two already exists
                            canCreateLink = false
                        }
                    }
                )
                canCreateLinkAll = canCreateLinkAll || canCreateLink
            }
        )

        return canCreateLinkAll
    }

    populateLinkRequestData = (linksData, skipCheck = false) => {
        let data = {
            request: [],
            sNodeIdx: [],
            tNodeIdx: []
        }
        linksData.forEach(
            linkData => {

                let srcNode = this.state.nodesData[this.state.nodesHashTable[linkData.sourceNodeId]]
                let targetNode = this.state.nodesData[this.state.nodesHashTable[linkData.targetNodeId]]
                let linkHash = linkData.linkHash

                let link = {
                    from_id: srcNode.id,
                    to_id: targetNode.id,
                    linkHash: linkHash,
                    _selectionId: -1,
                    _cullPassed: true
                }

                var canCreateLink = true
                canCreateLink = (link.from_id !== link.to_id)
                srcNode.linksList.forEach(
                    linkId => {
                        var _link = this.state.linksData[this.state.linksHashTable[linkId]]
                        if ((_link.from_id === srcNode.id && _link.to_id === targetNode.id) ||
                            (_link.from_id === targetNode.id && _link.to_id === srcNode.id)
                        ) {
                            // link between these two already exists
                            canCreateLink = false
                        }
                    }
                )

                if (canCreateLink || skipCheck) {
                    let _from_node = this.state.nodesData[this.state.nodesHashTable[srcNode.id]]
                    let _to_node = this.state.nodesData[this.state.nodesHashTable[targetNode.id]]
                    let _weights = (Math.abs(_from_node.x - _to_node.x) > Math.abs(_from_node.y - _to_node.y))
                        ? {
                            w1x: 0.75,
                            w1y: 0.0,
                            w2x: 0.25,
                            w2y: 1.0,
                        } : {
                            w1x: 0.0,
                            w1y: 0.75,
                            w2x: 1.0,
                            w2y: 0.25,
                        }
                    let index = data.request.length
                    data.request.push({
                        from_id: srcNode.id,
                        to_id: targetNode.id,
                        index: index,
                        linkHash: linkHash,
                        properties: {
                            w1x: _weights.w1x,
                            w1y: _weights.w1y,
                            w2x: _weights.w2x,
                            w2y: _weights.w2y,
                            type: 'similarity',
                            color: '#cacaca',
                            width: 1,
                            ...linkData.props
                        }
                    })
                    data.sNodeIdx.push(linkData.sourceNodeId)
                    data.tNodeIdx.push(linkData.targetNodeId)
                }
            }
        )
        return data;
    }

    sendLinkCreateData = (data, cb) => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/links/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ data: data.request })
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    response.data.forEach(value => {
                        let link = {}
                        link.from_id = value.from_id
                        link.to_id = value.to_id
                        link._selectionId = -1
                        link._cullPassed = true
                        link.id = value.id
                        link.properties = value.properties

                        let srcNode = this.state.nodesData[this.state.nodesHashTable[data.sNodeIdx[value.index]]]
                        let targetNode = this.state.nodesData[this.state.nodesHashTable[data.tNodeIdx[value.index]]]
                        srcNode.linksList.push(link.id)
                        link.x1 = srcNode.x
                        link.y1 = srcNode.y
                        targetNode.linksList.push(link.id)
                        link.x2 = targetNode.x
                        link.y2 = targetNode.y

                        this.state.linksData.push(link)
                        this.state.linksHashTable[link.id] = this.state.linksData.length - 1
                    })
                    this.setState({
                        linksData: this.state.linksData,
                    },
                        () => {
                            if (cb) {
                                cb()
                            }
                        })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            })
    }

    createLinks = (linksData, skipCheck = false, cb = null) => {
        let data = this.populateLinkRequestData(linksData, skipCheck);
        this.sendLinkCreateData(data, cb);
    }

    createLink = (targetNodeData, srcNodes = this.state.selection.nodes, skipCheck = false, props = {}, cb = null) => {
        let data = this.populateLinkRequestData(srcNodes.map((id) => {
            return ({
                sourceNodeId: id,
                targetNodeId: targetNodeData.id,
                props: props
            })
        }))
        this.sendLinkCreateData(data, cb);
    }

    selectNode = (nodeItem, isDrag = false, skipTrigger = false) => {

        var selected = {
            nodes: [],
            links: [],
        }
        var deselected = {
            nodes: [],
            links: [],
        }

        if (!this.keyPressDict.link) {
            if (!nodeItem) {
                deselected = this.deselectAll()
            } else {
                // ordinary click -> select only that node
                if (!this.keyPressDict.ctrl) {
                    // TODO ovde moze optimizacija da se ne deselektuje pa ponovo selektuje vec ranije selektovan node
                    if (!isDrag || nodeItem._selectionId === -1)
                        deselected = this.deselectAll()
                    if (nodeItem._selectionId === -1) {
                        this.state.selection.nodes.push(nodeItem.id)
                        nodeItem._selectionId = this.state.selection.nodes.length - 1
                        selected.nodes = [nodeItem.id]
                    }
                }
                // toggle selection
                else {
                    if (!isDrag) {
                        if (nodeItem._selectionId === -1) {
                            this.state.selection.nodes.push(nodeItem.id)
                            nodeItem._selectionId = this.state.selection.nodes.length - 1
                            selected.nodes = [nodeItem.id]
                        } else {
                            //deselect node
                            var idInSelection = nodeItem._selectionId
                            nodeItem._selectionId = -1
                            var selCount = this.state.selection.nodes.length
                            if (idInSelection !== selCount - 1) {
                                var lastNodeFromSelection = this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[selCount - 1]]]
                                lastNodeFromSelection._selectionId = idInSelection
                                this.state.selection.nodes[idInSelection] = lastNodeFromSelection.id
                            }
                            this.state.selection.nodes.pop()
                            deselected.nodes = [nodeItem.id]
                        }
                    }
                }
            }
        }

        // sln

        var change = {
            selected: selected,
            deselected: deselected,
        }

        // console.clear()
        // console.log(`${selected.nodes.length||deselected.nodes.length?'NODES\n':''}${selected.nodes.length?`    + ${selected.nodes}\n`:''}${deselected.nodes.length?`    - ${deselected.nodes}\n`:''}${selected.links.length||deselected.links.length?'LINKS\n':''}${selected.links.length?`    + ${selected.links}\n`:''}${deselected.links.length?`    - ${deselected.links}\n`:''}SELECTION: (${this.state.selection.nodes}) (${this.state.selection.links})`)

        if (change.selected.nodes.length !== 0 || change.deselected.nodes.length !== 0 ||
            change.selected.links.length !== 0 || change.deselected.links.length !== 0) {
            // this.setState({selection: this.state.selection})
            if (!skipTrigger) {
                this.nodebookDetails.selectionChangeHandler(change)
                this.nodebookSidebar.selectionChangeHandler(change)
                this.nodebookComponent.selectionChangeHandler(change)
            }
        }

        // Export bibtex button show/hide (using d3 to avoid setstate for now
        // maybe not needed?)
        let found = false;
        if (this.state.selection.nodes.length > 0) {
            for (let i = 0; i < this.state.selection.nodes.length; ++i) {
                if (this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[i]]].properties.templateId === 10) {
                    found = true;
                    break;
                }
            }
        }
        if (found) {
            this.copyBibtexRef.style('display', 'inline-block')
        } else {
            this.copyBibtexRef.style('display', 'none')
        }

        return change
    }

    selectMultipleNodes = (nodes, skipDeselect = false) => {

        if (!skipDeselect) {
            this.selectNode()
        }
        if (nodes.length === 0) {
            return
        }
        // var oldCtrl = this.keyPressDict.ctrl
        // this.keyPressDict.ctrl = true
        // nodes.forEach((node, id)=>this.selectNode(node, false, true))
        // this.keyPressDict.ctrl = oldCtrl

        nodes.forEach(node => {
            if (node._selectionId === -1) {
                node._selectionId = this.state.selection.nodes.length
                this.state.selection.nodes.push(node.id)
            }
        })

        var change = {
            selected: {
                nodes: nodes.map(node => node.id),
                links: []
            },
            deselected: {
                nodes: [],
                links: []
            },
        }

        this.nodebookDetails.selectionChangeHandler(change)
        this.nodebookSidebar.selectionChangeHandler(change)
        this.nodebookComponent.selectionChangeHandler(change)

        return change
    }

    selectLink = (linkItem) => {

        var selected = {
            nodes: [],
            links: [],
        }
        var deselected = {
            nodes: [],
            links: [],
        }

        if (!linkItem) {
            console.log("%c USE EMPTY SELECT NODE FOR DESEELCT !!!", 'color: red')
        } else {
            if (!this.keyPressDict.ctrl) {
                // normalan, pojedinacan select
                if (linkItem._selectionId === -1) {
                    deselected = this.deselectAll()
                    this.state.selection.links.push(linkItem.id)
                    linkItem._selectionId = this.state.selection.links.length - 1
                    selected.links = [linkItem.id]
                }
            } else {
                // toggle select
                if (linkItem._selectionId === -1) {
                    // nije jos uvek selektovan
                    this.state.selection.links.push(linkItem.id)
                    linkItem._selectionId = this.state.selection.links.length - 1
                    selected.links = [linkItem.id]
                } else {
                    // bio je vec selektovan
                    var idInSelection = linkItem._selectionId
                    linkItem._selectionId = -1
                    var selCount = this.state.selection.links.length
                    if (idInSelection !== selCount - 1) {
                        var lastLinkFromSelection = this.state.linksData[this.state.linksHashTable[this.state.selection.links[selCount - 1]]]
                        lastLinkFromSelection._selectionId = idInSelection
                        this.state.selection.links[idInSelection] = lastLinkFromSelection.id
                    }
                    this.state.selection.links.pop()
                    deselected.links = [linkItem.id]
                }
            }
        }

        var change = {
            selected: selected,
            deselected: deselected,
        }

        // console.clear()
        // console.log(`${selected.nodes.length||deselected.nodes.length?'NODES\n':''}${selected.nodes.length?`    + ${selected.nodes}\n`:''}${deselected.nodes.length?`    - ${deselected.nodes}\n`:''}${selected.links.length||deselected.links.length?'LINKS\n':''}${selected.links.length?`    + ${selected.links}\n`:''}${deselected.links.length?`    - ${deselected.links}\n`:''}SELECTION: (${this.state.selection.nodes}) (${this.state.selection.links})`)

        if (change.selected.nodes.length !== 0 || change.deselected.nodes.length !== 0 ||
            change.selected.links.length !== 0 || change.deselected.links.length !== 0) {
            // this.setState({selection: this.state.selection})
            this.nodebookDetails.selectionChangeHandler(change)
            this.nodebookSidebar.selectionChangeHandler(change)
            this.nodebookComponent.selectionChangeHandler(change)
        }

        return change
    }

    deselectAll = () => {
        var deselected = {}
        var i;

        // deselektuj sve nodove
        for (i = 0; i < this.state.selection.nodes.length; i++) {
            let nodeItem = this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[i]]]
            nodeItem._selectionId = -1
        }
        deselected.nodes = this.state.selection.nodes
        this.state.selection.nodes = []

        // deselektuj sve linkove
        for (i = 0; i < this.state.selection.links.length; i++) {
            let linkItem = this.state.linksData[this.state.linksHashTable[this.state.selection.links[i]]]
            linkItem._selectionId = -1
        }
        deselected.links = this.state.selection.links
        this.state.selection.links = []

        return deselected
    }

    // curveAllLinks = (straighten=false) => {
    //     if (straighten) {
    //         var links = this.state.linksData.map(link=>link.id)
    //         this.updateLinksRemotely(links, {
    //             w1x: 0.333,
    //             w1y: 0.333,
    //             w2x: 0.667,
    //             w2y: 0.667,
    //         })
    //         return
    //     }

    //     var linksV = []
    //     var linksH = []
    //     this.state.linksData.forEach(link=>{
    //         if (Math.abs(link.x1-link.x2)>Math.abs(link.y2-link.y1)) {
    //             linksH.push(link.id)
    //         } else {
    //             linksV.push(link.id)
    //         }
    //     })

    //     this.updateLinksRemotely(linksH, {
    //         w1x: 0.75,
    //         w1y: 0.0,
    //         w2x: 0.25,
    //         w2y: 1.0,
    //     })

    //     this.updateLinksRemotely(linksV, {
    //         w1x: 0.0,
    //         w1y: 0.75,
    //         w2x: 1.0,
    //         w2y: 0.25,
    //     })
    // }

    shareView = () => {
        try {
            let transformation = JSON.parse(localStorage.getItem(`ndbk${this.props.match.params.id}_transformations`))
            let nodeIds = this.state.selection.nodes.join(',')
            this.setState({ shareViewLink: `https://nodebook.io/nodebook/${this.props.match.params.id}/t/${this.state.nodebookInfo.visibility === 'private' ? `token=${this.state.nodebookInfo.shareToken}&` : ''}x=${transformation.x.toFixed(2)}&y=${transformation.y.toFixed(2)}&k=${transformation.k.toFixed(2)}${(nodeIds !== '') ? '&ids=' + nodeIds : ''}` }, () => {
                this.shareViewLinkInput.value = this.state.shareViewLink
                this.shareViewLinkInput.select()
                this._isShareView = true
                var copySucceded = document.execCommand('copy')
                if (copySucceded) {
                    this.shareMessageRef
                        .style('display', 'block')
                        .style('opacity', 1)
                        .transition()
                        .delay(3000)
                        .duration(3000)
                        .style('opacity', 0)
                        .on('end', function () {
                            d3.select(this).style('display', 'none')
                        })
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    copyNodeUrl = () => {
        let nodeIds = this.getSelection().nodes;
        this.setState({ copyNodeLink: `https://nodebook.io/nodebook/${this.props.match.params.id}/t/ids=${nodeIds.join(',')}` }, () => {
            this.copyNodeLinkInput.value = this.state.copyNodeLink
            this.copyNodeLinkInput.select()
            //this._isShareView = true
            let success = document.execCommand('copy')
            if (success) {
                this.hideCtxMenus()
            }
        })
    }

    copyBibtex = () => {
        try {
            let bibtex = "";
            this.state.selection.nodes.forEach(nodeId => {
                let node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                if (node.properties.templateId === 10) {
                    let props = []
                    if (node.properties.title && node.properties.title !== "") props.push(`title = {{${node.properties.title}}}`)
                    if (node.properties.authors.length > 0) props.push(`author = {${node.properties.authors.join(' and ')}}`)
                    if (node.properties.journal && node.properties.journal !== "") props.push(`journal = {${node.properties.journal}}`)
                    if (node.properties.volume && node.properties.volume !== "") props.push(`volume = {${node.properties.volume}}`)
                    if (node.properties.publisher && node.properties.publisher !== "") props.push(`publisher = {${node.properties.publisher}}`)
                    if (node.properties.issue && node.properties.issue !== "") props.push(`issue = {${node.properties.issue}}`)
                    if (node.properties.year && node.properties.year !== "") props.push(`year = {${node.properties.year}}`)
                    if (node.properties.abstract && node.properties.abstract !== "") props.push(`absract = {${node.properties.abstract}}`)
                    if (node.properties.keywords.length > 0) props.push(`keywords = {${node.properties.keywords.join(', ')}}`)
                    if (node.properties.url.length > 0) props.push(`url = {${node.properties.url.map(url => url.href).join(', ')}}`)
                    if (node.properties.tags.length > 0) props.push(`tags = {${node.properties.tags.join(', ')}}`)
                    if (node.properties.arxivId && node.properties.arxivId !== "") props.push(`arxivId = {${node.properties.arxivId}}`)
                    if (node.properties.doi && node.properties.doi !== "") props.push(`doi = {${node.properties.doi}}`)
                    if (node.properties.isbn && node.properties.isbn !== "") props.push(`isbn = {${node.properties.isbn}}`)
                    if (node.properties.issn && node.properties.issn !== "") props.push(`issn = {${node.properties.issn}}`)
                    if (node.properties.pmid && node.properties.pmid !== "") props.push(`pmid = {${node.properties.pmid}}`)
                    let titleFirstWord = ''
                    if (node.properties.title.match(/([^\s]+)/) !== null) {
                        let matches = node.properties.title.match(/([^\s]+)/gm)
                        for (let i = 0; i < matches.length; ++i) {
                            let match = matches[i]
                            if (match.toLocaleLowerCase() !== 'a' && match.toLocaleLowerCase() !== 'an' && match.toLocaleLowerCase() !== 'the') {
                                titleFirstWord = matches[i]
                                break;
                            }
                        }
                    }
                    let year = node.properties.year
                    if (year === undefined) year = ''
                    let lastName = ((node.properties.authors[0] || "").match(/([^,\s]+)/) !== null) ? (node.properties.authors[0] || "").match(/([^,\s]+)/)[0] : ''
                    let citationKey = lastName + year + titleFirstWord
                    if (citationKey === '') citationKey = 'NoReference'
                    citationKey = citationKey.replace(/,/g, '.');
                    let wrapper = `@article{${citationKey.toLocaleLowerCase()},\r\n${props.join(',\n')}\n}\n`;
                    bibtex = bibtex + wrapper
                }
            })
            let showMessage = (message) => {
                this.copyBibtexMessageRef
                    .html(message)
                    .style('display', 'block')
                    .style('opacity', 1)
                    .transition()
                    .delay(3000)
                    .duration(3000)
                    .style('opacity', 0)
                    .on('end', function () {
                        d3.select(this).style('display', 'none')
                    })
            }
            if (bibtex !== "") {
                this.setState({ bibtexCopyText: bibtex }, () => {
                    this.bibtexCopyTextInput.value = this.state.bibtexCopyText
                    this.bibtexCopyTextInput.select()
                    //_isShareView just for flagging the copy command listener
                    this._isShareView = true
                    var copySucceded = document.execCommand('copy')
                    if (copySucceded) {
                        showMessage('BibTeX copied to clipboard')
                    }
                })
            } else {
                showMessage('No academic nodes selected')
            }

        } catch (err) {
            console.log(err)
        }
    }

    updateLinksLocally = (linkIds, props, cb = null) => {
        linkIds.forEach(
            linkId => {
                var link = this.state.linksData[this.state.linksHashTable[linkId]]
                this.state.linksData[this.state.linksHashTable[linkId]].properties = { ...link.properties, ...props }

                // Object.assign(this.state.linksData[this.state.linksHashTable[linkId]], props)

                // Object.keys(props).forEach(
                //     propName => {
                //         // console.log('updating '+propName)
                //         this.state.linksData[this.state.linksHashTable[linkId]][propName] = props[propName]
                //     }
                // )
            }
        )
        this.setState({
            linksData: this.state.linksData
        }, () => {
            if (cb) {
                cb()
            }
        })
    }

    updateLinksRemotely = (linkIds, props, cb = null) => {
        if (this.state.nodebookInfo && this.state.nodebookInfo.canEdit !== true) {
            if (cb) {
                cb()
            }
            return
        }

        if (linkIds.length === 0) {
            if (cb) {
                cb()
            }
            return
        }

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/links/update`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ids: linkIds,
                properties: props
            }),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if (cb) {
                        cb()
                    }
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    updateNodesLocally = (nodeIds, props, cb = null) => {
        let isPropsArray = Array.isArray(props)
        nodeIds.forEach(
            (nodeId, index) => {
                var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                try {
                    const { x, y, width, height, settings, ...rest } = (isPropsArray ? props[index] : props)
                    node.properties = { ...node.properties, ...rest }
                } catch (err) {
                    //WIP
                }
                // if ( settings !== undefined) {
                //     Object.keys(settings).forEach(
                //         value => node.settings[value] = {...node.settings[value], ...settings[value]}
                //     )
                // }
            }
        )
        this.setState({
            nodesData: this.state.nodesData
        }, () => {
            if (cb) {
                cb()
            }
        })
    }

    updateNodesRemotely = (nodeIds, props, cb = null) => {
        if (this.state.nodebookInfo && this.state.nodebookInfo.canEdit !== true) {
            if (cb) {
                cb()
            }
            return
        }

        if (nodeIds.length === 0) {
            if (cb) {
                cb()
            }
            return
        }

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/nodes/update`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ids: nodeIds,
                properties: props,
            }),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if (cb) {
                        cb()
                    }
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    selectionUpdateAll = (props, pick = this.state.selection, cb = null, shouldUpdateLocalData = true, forceUpdate = false) => {
        if (this.state.isCompare && !forceUpdate) {
            return
        }
        if (this.state.nodebookInfo.authToken) {
            // nodes
            let nodeIds = pick.nodes
            this.updateNodesRemotely(nodeIds, props, () => {
                if (shouldUpdateLocalData) {
                    this.updateNodesLocally(nodeIds, props, cb)
                } else {
                    if (cb) {
                        cb()
                    }
                }
            })
            // links
            let linkIds = pick.links
            this.updateLinksRemotely(linkIds, props, () => {
                if (shouldUpdateLocalData) {
                    this.updateLinksLocally(linkIds, props, cb)
                } else {
                    if (cb) {
                        cb()
                    }
                }
            })
        }
    }

    _triggerSetNodes = () => {
        this.setState({
            nodesData: this.state.nodesData,
            linksData: this.state.linksData
        })
    }

    selectionUpdateAllLocalFirst = (props, pick = this.state.selection, cb = null) => {
        if (this.state.nodebookInfo.authToken) {
            // nodes
            let nodeIds = pick.nodes
            this.updateNodesLocally(nodeIds, props, cb)
            this.updateNodesRemotely(nodeIds, props)

            // links
            let linkIds = pick.links
            this.updateLinksLocally(linkIds, props, cb)
            this.updateLinksRemotely(linkIds, props)
        }
    }

    deleteLinksLocally = (linkIds, cb = null) => {
        // let _removedLinks = []
        if (!linkIds) {
            return
        }

        for (var i = 0; i < linkIds.length; i++) {
            let link = this.state.linksData[this.state.linksHashTable[linkIds[i]]]
            if (link) {
                link._jsx.styleFade()
            }
        }

        setTimeout(() => {

            // remove links from local data
            for (var i = 0; i < linkIds.length; i++) {
                var _id = this.state.linksHashTable[linkIds[i]]
                var link = this.state.linksData[_id]

                if (!link) {
                    // console.log("ERROR!! (ok)")
                    continue
                }

                if (link.id !== linkIds[i]) {
                    console.log("ERROR!!")
                    continue
                }

                // remove from selection
                if (link._selectionId !== -1) {
                    var idInSelection = link._selectionId
                    var selCount = this.state.selection.links.length
                    if (idInSelection !== selCount - 1) {
                        var lastLinkFromSelection = this.state.linksData[this.state.linksHashTable[this.state.selection.links[selCount - 1]]]
                        lastLinkFromSelection._selectionId = idInSelection
                        this.state.selection.links[idInSelection] = lastLinkFromSelection.id
                    }
                    this.state.selection.links.pop()
                    // if (pick===this.state.selection) {
                    //     i--
                    // }
                }

                // remove link from lists of 'from' and 'to' nodes
                var fromNode = this.state.nodesData[this.state.nodesHashTable[link.from_id]]
                if (fromNode) {
                    var idxInList = fromNode.linksList.indexOf(link.id)
                    if (idxInList !== -1) {
                        fromNode.linksList.splice(idxInList, 1)
                    } else {
                        // console.log("ERROR!! (ok)")
                    }
                }

                var toNode = this.state.nodesData[this.state.nodesHashTable[link.to_id]]
                if (toNode) {
                    var idxInList = toNode.linksList.indexOf(link.id)
                    if (idxInList !== -1) {
                        toNode.linksList.splice(idxInList, 1)
                    } else {
                        // console.log("ERROR!! (ok)")
                    }
                }

                // remove from actual data
                if (_id !== this.state.linksData.length - 1) {
                    var lastLink = this.state.linksData[this.state.linksData.length - 1]
                    this.state.linksData[_id] = lastLink
                    this.state.linksHashTable[lastLink.id] = _id
                }
                this.state.linksHashTable[link.id] = null
                this.state.linksData.pop()
            }

            // timeout is used to make sure that links' fade animation has finished

            this.setState({
                linksData: this.state.linksData,
            }, () => {
                this.nodebookDetails.selectionChangeHandler(null)
                if (cb) {
                    cb(linkIds)
                }
            })
        }, 420)
    }

    deleteLinksRemotely = (linkIds, cb = null) => {
        if (linkIds.length === 0) {
            if (cb) {
                cb()
            }
            return
        }

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/links/delete`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ids: linkIds }),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if (cb) {
                        cb(linkIds)
                    }
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    deleteNodesLocally = (nodeIds, cb = null) => {
        // var _linksToBeDeleted = []
        var _removedNodes = []

        for (var i = 0; i < nodeIds.length; i++) {
            var node = this.state.nodesData[this.state.nodesHashTable[nodeIds[i]]]
            if (node) {
                node._jsx.styleFade()
            }
        }

        setTimeout(() => {

            // remove nodes from local data
            for (var i = 0; i < nodeIds.length; i++) {
                var _id = this.state.nodesHashTable[nodeIds[i]]
                var node = this.state.nodesData[_id]

                if (!node) {
                    continue
                }

                // remove from selection
                if (node._selectionId !== -1) {
                    var idInSelection = node._selectionId
                    var selCount = this.state.selection.nodes.length
                    if (node._selectionId !== selCount - 1) {
                        var lastNodeFromSelection = this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[selCount - 1]]]
                        lastNodeFromSelection._selectionId = idInSelection
                        this.state.selection.nodes[idInSelection] = lastNodeFromSelection.id
                    }
                    this.state.selection.nodes.pop()
                    // if (pick===this.state.selection) {
                    //     i--
                    // }
                }

                // remove links, i.e. schedule them for deletion
                // node.linksList.forEach(linkId=>_linksToBeDeleted.push(linkId))

                _removedNodes.push(node)
                // node._jsx.styleFade()

                if (_id !== this.state.nodesData.length - 1) {
                    // prebaci poslednji node na upraznjeno mesto
                    var lastNode = this.state.nodesData[this.state.nodesData.length - 1]
                    this.state.nodesData[_id] = lastNode
                    this.state.nodesHashTable[lastNode.id] = _id
                }
                // this.state.nodesHashTable[pick.nodes[i]] = null
                this.state.nodesData.pop()
            }

            this.nodebookComponent.dataChangeHandler({
                created: [],
                deleted: _removedNodes
            })

            this.nodebookDetails.selectionChangeHandler(null, () => {
                _removedNodes = []
                this.setState({
                    nodesData: this.state.nodesData,
                }, () => {
                    if (cb) {
                        cb(nodeIds/*, _linksToBeDeleted*/)
                    }
                })
            })

        }, 420)
    }

    deleteNodesRemotely = (nodeIds, cb = null) => {
        if (nodeIds.length === 0) {
            if (cb) {
                cb()
            }
            return
        }

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/nodes/delete`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ids: nodeIds }),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if (cb) {
                        cb(nodeIds)
                    }
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    selectionDeleteAll = (pick = this.state.selection, forceDel = false) => {

        this.keyPressDict.link = false

        if (this.state.isCompare && !forceDel) {
            return
        }

        var nodeIds = [...pick.nodes]
        var linkIds = [...pick.links]

        nodeIds.forEach(nodeId => {
            let node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
            this.nodebookComponent.dehighlightConnections(node);
            node.linksList.forEach(linkId => linkIds.push(linkId))
        })

        this.deleteNodesRemotely(nodeIds, () => {
            this.deleteNodesLocally(nodeIds)
        })

        this.deleteLinksRemotely(linkIds, () => {
            this.deleteLinksLocally(linkIds)
        })
    }

    onDrop = (acceptedFiles) => {

        if (this.state.nodebookInfo && this.state.nodebookInfo.canEdit !== true) {
            return
        }

        var NumberOfFiles = acceptedFiles.length;
        var { x, y } = this.getMiddle()
        let squareSide = Math.ceil(Math.sqrt(NumberOfFiles))
        let height = 90;
        let width = 200;
        let data = []
        let uploadToNodes = (nodes) => {
            // select and move to nodes uploading
            this.selectMultipleNodes(nodes)
            this.transformToSelection()

            nodes.forEach(node => {
                let file = acceptedFiles[nameToIndex[node.properties.title]]
                let id = node.id
                this.onNodeFileInput(file, id, (data) => {
                    this.updateNodesLocally([id], {
                        files: [{
                            url: data.file,
                            name: file.name,
                            size: file.size,
                            date: Date.now()
                        }],
                        color: 'white'
                    })
                })
            })
        }

        let nameToIndex = {}

        data = acceptedFiles.map((file, index) => {
            nameToIndex[file.name] = index
            return (
                {
                    properties: {
                        height: height,
                        width: width,
                        x: (x + (index % squareSide) * width + 5),
                        y: (y + (Math.floor(index / squareSide)) * height + 5),
                        title: file.name,
                        fileName: file.name,
                        templateId: 10
                    },
                }
            )
        })

        this.createNodes(data, uploadToNodes, false, true, true)

    }

    //endregion
    //---------------------------------------------------------

    //region FILE UPLOAD
    onBibtexInput = (files = null, text = null) => {

        let _formData = new FormData()

        let reqParse = () => {
            fetch(`https://${constants.SERVER_IP}/api/import_bibtex`, {
                method: 'POST',
                body: _formData,
                credentials: 'include',
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        this.makeNodesFromData(response.data)
                    }
                })
                .catch((err) => { })
        }

        // send files for parsing
        if (files) {
            var file = files[0]
            const reader = new FileReader()
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                // const fileAsBinaryString = reader.result;
                _formData.append('bibtex', file)
                reqParse()
            }
            try {
                reader.readAsBinaryString(file)
            } catch (err) {
                console.error(err)
            }
        }

        // send text for parsing
        if (text) {
            _formData.append('text', text)
            reqParse()
        }

    }
    //endregion
    //---------------------------------------------------------
    placeBasicSearch = (searchString) => {
        this.state.searchParams = {
            mode: 'basic',
        }
        this.executeSearch()
    }

    toggleSearchMode = () => {
        if ('uber' === this.state.searchParams.mode) {
            this.setState({
                searchParams: {
                    mode: "basic",
                }
            })
        } else if ('basic' === this.state.searchParams.mode) {
            this.setState({
                searchParams: {
                    mode: "uber",
                }
            }, () => {
                // this.executeSearch()
            })
        } else {
            console.log("ERROR!!")
        }
    }

    executeSearch = (resultsLabel) => {
        var deselected = this.deselectAll()
        var availableGroups = []

        if (this.state.searchParams.mode === 'basic') {
            var matching = null
            var searchInput = resultsLabel
            var semicolonId = searchInput.indexOf(':')
            if (-1 === semicolonId) {
                matching = SearchOps.matchAny(this.state.nodesData, searchInput)
            } else {
                var fieldName = searchInput.substring(0, semicolonId)
                var searchValue = searchInput.substring(semicolonId + 1)
                matching = SearchOps.matchField(this.state.nodesData, fieldName, searchValue)
            }

            if (resultsLabel !== '') {
                availableGroups.push({
                    _set: matching,
                    value: 'Basic search'
                })
                this.nodebookSidebar.forceShowResults(availableGroups, 'Basic search')
            } else {
                // this.nodebookSidebar.forceUpdateResults(availableGroups)
            }

            this.sidebarHide(null, true)
        } else {
            // get execution plan
            if (!this.nodebookComponent || !this.nodebookComponent._refs.uber) {
                return
            }

            var uberExePlan = this.nodebookComponent._refs.uber.getExecutionPlan()
            var terminals = []
            // execute plan in order that it was received
            for (var ui = 0; ui < uberExePlan.length; ui++) {
                var uberItem = uberExePlan[ui]
                switch (uberItem.type) {
                    case 'match':
                        if (uberItem.fieldName === 'all') {
                            uberItem._set = SearchOps.matchAny(this.state.nodesData, uberItem.value, uberItem.invert)
                        } else {
                            uberItem._set = SearchOps.matchField(this.state.nodesData, uberItem.fieldName, uberItem.value, uberItem.invert)
                        }
                        break
                    case 'union':
                        uberItem._set = new Set()
                        for (var i = 0; i < uberItem.inputs.length; i++) {
                            SearchOps.unionInplace(uberItem._set, uberExePlan[uberItem.inputs[i]]._set)
                        }
                        break
                    case 'intersect':
                        uberItem._set = new Set(uberExePlan[uberItem.inputs[0]]._set)
                        for (var i = 1; i < uberItem.inputs.length; i++) {
                            uberItem._set = SearchOps.intersect(uberItem._set, uberExePlan[uberItem.inputs[i]]._set)
                        }
                        break
                    case 'link':
                        // do union first
                        uberItem._set = new Set()
                        for (var i = 0; i < uberItem.inputs.length; i++) {
                            SearchOps.unionInplace(uberItem._set, uberExePlan[uberItem.inputs[i]]._set)
                        }
                        // do link+1
                        for (var _li = 0; _li < uberItem.value; _li++) {
                            uberItem._set = SearchOps.link(this.state.nodesData, this.state.nodesHashTable, this.state.linksData, this.state.linksHashTable, uberItem._set)
                        }
                        break
                    case 'group':
                        // do union first
                        uberItem._set = new Set()
                        for (var i = 0; i < uberItem.inputs.length; i++) {
                            SearchOps.unionInplace(uberItem._set, uberExePlan[uberItem.inputs[i]]._set)
                        }
                        // do grouping
                        // (already done at this point)
                        terminals.push(ui)
                        break
                    default:
                        alert('Unrecognized uber command.')
                }
            }

            for (var ti = 0; ti < terminals.length; ti++) {
                var terminal = uberExePlan[terminals[ti]]
                // if (terminal._set.length>0) {
                availableGroups.push(terminal)
                // }
            }

            if (availableGroups.length > 0 || uberExePlan.length === 0) {
                this.nodebookSidebar.forceUpdateResults(availableGroups)
            }
        }

        // this.sidebarHide(null, true)
    }

    uberCreateNode = (opType) => {
        if (this.nodebookComponent && this.nodebookComponent._refs.uber) {
            this.nodebookComponent._refs.uber.createUberNode(opType)
        }
    }

    showCtxMenu = (name, x, y, data = {}) => {
        var elem = undefined
        this.keyPressDict.link = false
        this.ctxMenuData = data
        if ('node' === name) {
            var node = this.state.nodesData[this.state.nodesHashTable[data.nodeId]]
            if (node._selectionId === -1) {
                this.selectNode()
                this.selectNode(node)
            }
            elem = this.ctxMenuNode
        } else if ('svg' === name) {
            elem = this.ctxMenuSvg
        } else if ('link' === name) {
            var link = this.state.linksData[this.state.linksHashTable[data.linkId]]
            if (link._selectionId === -1) {
                this.selectNode()
                this.selectLink(link)
            }
            elem = this.ctxMenuLink
        }
        elem.style('display', 'block')
        elem.style('left', `${x}px`)
        elem.style('top', `${y}px`)

        this.keyPressDict.link = false

        d3.event.preventDefault()
        d3.event.stopPropagation()
    }

    hideCtxMenus = () => {
        if (this.ctxMenuSvg && this.ctxMenuLink && this.ctxMenuNode) {
            this.ctxMenuSvg.style('display', 'none')
            this.ctxMenuLink.style('display', 'none')
            this.ctxMenuNode.style('display', 'none')
        }
    }

    cmdCutNodes = (e) => {
        this.cmdCopyNodes(e)
        this.selectionDeleteAll()
    }

    cmdCopyNodes = (event) => {
        console.log('copy attempt')
        this.hideCtxMenus()

        let czt = this.nodebookComponent.currentZoomTransform
        let firstSelectionNode = (this.state.selection.nodes.length > 0)
            ? this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[0]]]
            : null

        var ccp_data = {
            nodes: [],
            links: []
        }

        // copy nodes
        this.state.selection.nodes.forEach(
            nodeId => {
                var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                ccp_data.nodes.push({
                    properties: {
                        ...node.properties,
                        x: (node.id === firstSelectionNode.id)
                            ? node.x * czt.k + czt.x
                            : firstSelectionNode.x - node.x,
                        y: (node.id === firstSelectionNode.id)
                            ? node.y * czt.k + czt.y
                            : firstSelectionNode.y - node.y,
                        width: node.width,
                        height: node.height,
                    },
                    file_hash: node.file_hash,
                    nodebook_id: this.props.match.params.id,
                    nodebook_node_id: node.id
                })

                // copy links
                node.linksList.forEach(linkId => {
                    let link = this.state.linksData[this.state.linksHashTable[linkId]]
                    let otherNodeId = link.from_id === node.id ? link.to_id : link.from_id
                    let otherNode = this.state.nodesData[this.state.nodesHashTable[otherNodeId]]
                    if (otherNode._selectionId !== -1) {                          // this node is also in selection, so copy this link
                        if (node._selectionId < otherNode._selectionId) {       // this ensures that we copy link only once, instead of twice for each connected node
                            ccp_data.links.push({
                                _from_id: link.from_id === node.id ? node._selectionId : otherNode._selectionId,
                                _to_id: link.from_id === node.id ? otherNode._selectionId : node._selectionId,
                                properties: link.properties,
                            })
                        }
                    }
                })
            }
        )

        event.clipboardData.setData('nodebook/nodes', JSON.stringify(ccp_data));
        //Cookies.set('cut_copy_paste_data', ccp_data)
        localStorage.setItem('cut_copy_paste_data', JSON.stringify(ccp_data))
    }

    cmdCopyNodebookRef = () => {
        this.hideCtxMenus()

        var ccp_data = {
            nodes: [],
            links: []
        }

        ccp_data.nodes.push({
            properties: {
                x: 0,
                y: 0,
                width: 200,
                height: 20,
                title: this.state.nodebookInfo.title,
                templateId: 2,
            },
            nodebook_id: this.props.match.params.id,
            nodebook_node_id: null
        })

        //localStorage.setItem('cut_copy_paste_data', JSON.stringify(ccp_data))
    }

    cmdPasteNodes = (pasteAsRef = false, isNodes, pastedData) => {
        this.hideCtxMenus()
        if (!isNodes) {
            // var clipboardData = d3.event.clipboardData || window.clipboardData;
            // var linkRegex = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi)
            // if (pastedData.match(linkRegex)) {
            //     return
            // }

            // does it look like a bibtex format?
            if (pastedData.match(/@\w+\{/)) {
                this.onBibtexInput(null, pastedData)
            } else {
                // does it look like a link?
                //let expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
                let expression = /[-\w@:%\+.~#?&//=]{2,256}\.[a-z]{2,14}\b(\/[-\w@:%\+.~#?&//='()]*)?/gi
                let regex = new RegExp(expression);
                let t = pastedData;

                let urls = t.match(regex)

                if (urls) {
                    let NumberOfFiles = urls.length
                    let { x, y } = this.getMiddle()
                    let squareSide = Math.ceil(Math.sqrt(NumberOfFiles))

                    if (this.state.selection.nodes.length !== 0) {
                        let nodeIds = this.state.selection.nodes
                        let nodeURLs = []

                        let props = this.state.selection.nodes.map(nodeId => {
                            let _node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                            let url = [...urls.map(url => { return ({ title: url, href: url }) }), ..._node.properties.url]
                            //_node.properties.url =  [...urls.map(url=>{return({title: url, href:url})}), ..._node.properties.url]
                            return (
                                { url: url }
                            )
                        })

                        this.selectionUpdateAll(props, { nodes: nodeIds, links: [] }, null, true)
                        return
                    }

                    let data = urls.map((url, index) => {
                        return (
                            {
                                properties: {
                                    x: (x),
                                    y: (y + index * 110),
                                    image: 'http://nodebook.io/nodebook_profile_images/loader.gif',
                                    title: url,
                                    width: 270,
                                    height: 110,
                                    url: [{ title: url, href: url }],
                                    _render: {
                                        // authors: {
                                        //     ...TemplatesLib[12].fields.filter(f=>f.name==='authors')[0].default.render,
                                        //     display: false
                                        // },
                                        tags: {
                                            ...TemplatesLib[12].fields.filter(f => f.name === 'tags')[0].default.render,
                                            display: false
                                        },
                                        description: {
                                            ...TemplatesLib[12].fields.filter(f => f.name === 'description')[0].default.render,
                                            display: true,
                                            overflow: true,
                                        },
                                        title: {
                                            ...TemplatesLib[12].fields.filter(f => f.name === 'title')[0].default.render,
                                            overflow: true,
                                        },
                                    },
                                    //x: this.ctxMenuData.position.x,
                                    //y: this.ctxMenuData.position.y,
                                    templateId: 12
                                },
                            }
                        )
                    })

                    let fetchMeta = (nodes) => {
                        // select and move to nodes uploading
                        this.selectMultipleNodes(nodes)
                        this.transformToSelection()

                        nodes.forEach(node => {
                            let url = node.properties.url[0].href
                            let id = node.id
                            fetch(`https://${constants.SERVER_IP}/api/fetch-meta-data`, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ url: url })
                                //example url:'http://nodebook.io/nodebook/534'
                            })
                                .then((response) => response.json())
                                .then((response) => {
                                    if (response.success) {
                                        this.selectionUpdateAll({
                                            image: response.data.ogImage.url || '',
                                            title: response.data.ogTitle,
                                            url: [{ title: response.data.ogUrl, href: response.data.ogUrl }],
                                            description: response.data.ogDescription,
                                            // height: (response.data.ogImage.url!==undefined)?110:70,
                                        }, {
                                            nodes: [id],
                                            links: []
                                        })
                                    } else {
                                        this.selectionUpdateAll({
                                            image: '', //http://nodebook.io/public/nodebook_profile_images/default_thumbnail.jpg
                                            title: response.data.ogTitle,
                                            url: [{ title: response.data.ogUrl, href: response.data.ogUrl }],
                                            description: response.data.ogDescription,
                                            // height: 70,
                                        }, {
                                            nodes: [id],
                                            links: []
                                        })
                                    }
                                }).catch((error) => {
                                    console.error(error);
                                });
                        });
                    }
                    this.createNodes(data, fetchMeta)
                }
            }
        } else {
            var ccp_data = JSON.parse(pastedData)

            if (!ccp_data || !ccp_data.nodes) {
                return
            }

            let czt = this.nodebookComponent.currentZoomTransform

            var data = []
            for (var i = 0; i < ccp_data.nodes.length; i++) {
                var node = ccp_data.nodes[i]
                // node.properties.x += 30
                // node.properties.y += 30
                if (pasteAsRef) {
                    node.properties.ref = {
                        nodebook_id: node.nodebook_id,
                        node_id: node.nodebook_node_id
                    }
                }
                data.push({
                    properties: {
                        ...node.properties,
                        x: (i === 0)
                            ? (node.properties.x - czt.x) / czt.k + 30
                            : (ccp_data.nodes[0].properties.x - czt.x) / czt.k + node.properties.x + 30,
                        y: (i === 0)
                            ? (node.properties.y - czt.y) / czt.k + 30
                            : (ccp_data.nodes[0].properties.y - czt.y) / czt.k + node.properties.y + 30,
                    }
                })
            }
            this.createNodes(data, (madeNodes) => {

                this.selectMultipleNodes(madeNodes)

                if (!ccp_data || !ccp_data.links) {
                    return
                }

                // paste links OLD
                // ccp_data.links.forEach(link=>{
                //     const {_from_id, _to_id, ...rest} = link
                //     let props = rest.properties || {}
                //     let from_node = madeNodes[_from_id]
                //     let to_node = madeNodes[_to_id]
                //     this.createLink(to_node, [from_node.id], false, props)
                // })
                let linksData = ccp_data.links.map((link) => {
                    let { _from_id, _to_id, ...rest } = link
                    let props = rest.properties || {}
                    let from_node = madeNodes[_from_id]
                    let to_node = madeNodes[_to_id]
                    return ({ targetNodeId: to_node.id, sourceNodeId: from_node.id, props });
                })

                if (linksData.length > 0) {
                    this.createLinks(linksData, false)
                }
            })
        }
    }

    getMiddle = () => {
        var x = parseInt(this.nodebookComponent._refs.svg.attr('width'), 10) / 2
        var y = parseInt(this.nodebookComponent._refs.svg.attr('height'), 10) / 2
        x = (x - this.nodebookComponent.currentZoomTransform.x) / this.nodebookComponent.currentZoomTransform.k
        y = (y - this.nodebookComponent.currentZoomTransform.y) / this.nodebookComponent.currentZoomTransform.k
        return { x: x, y: y }
    }

    sendToFront = () => {
        var node = this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[0]]]
        var lastNode = this.state.nodesData[this.state.nodesData.length - 1]

        var nodeId = this.state.nodesHashTable[node.id]
        var lastNodeId = this.state.nodesHashTable[lastNode.id]

        this.state.nodesData[nodeId] = lastNode
        this.state.nodesData[this.state.nodesData.length - 1] = node

        this.state.nodesHashTable[node.id] = this.state.nodesData.length - 1
        this.state.nodesHashTable[lastNode.id] = nodeId

        this.setState({
            nodesData: this.state.nodesData
        })
    }

    sendToBack = () => {
        var node = this.state.nodesData[this.state.nodesHashTable[this.state.selection.nodes[0]]]
        var lastNode = this.state.nodesData[0]

        var nodeId = this.state.nodesHashTable[node.id]
        var lastNodeId = this.state.nodesHashTable[lastNode.id]

        this.state.nodesData[nodeId] = lastNode
        this.state.nodesData[0] = node

        this.state.nodesHashTable[node.id] = 0
        this.state.nodesHashTable[lastNode.id] = nodeId

        this.setState({
            nodesData: this.state.nodesData
        })
    }

    toggleHeatmap = () => {

        if (this._isHeatmapOn === undefined) {
            this._isHeatmapOn = true
        } else {
            this._isHeatmapOn = !this._isHeatmapOn
        }

        if (this._isHeatmapOn) {

            let maxConns = undefined
            let minConns = undefined
            // calculate min and max links
            this.state.nodesData.forEach((node, id) => {
                if (id === 0) {
                    maxConns = node.linksList.length
                    minConns = node.linksList.length
                } else {
                    if (node.linksList.length > maxConns) {
                        maxConns = node.linksList.length
                    }
                    if (node.linksList.length < minConns) {
                        minConns = node.linksList.length
                    }
                }
            })

            //let diff = maxConns - minConns
            maxConns = maxConns === 0 ? 1 : maxConns
            this.state.nodesData.forEach(node => {
                //let k = (node.linksList.length-minConns)/diff * 255.0
                //let k = (node.linksList.length-minConns)/diff * 255.0
                let base = 0;
                // until 359 back to 0 then to 60. diff of 120
                let full = 360;
                let a = 0.1;
                let multiplier = 240
                let k = Math.log((node.linksList.length + a * maxConns) / (a * maxConns)) / Math.log((maxConns + a * maxConns) / (a * maxConns));
                let r = multiplier - ((multiplier * k + base) % full);
                let l = 50
                //let b = 255.0 - k/2;
                node._oldCol = node.properties.color
                node.properties.color = `hsl(${r}, 80%, ${l}%)`
            })

            this.setState({
                nodesData: this.state.nodesData
            })
        } else {
            this.state.nodesData.forEach(node => {
                node.properties.color = node._oldCol
            })

            this.setState({
                nodesData: this.state.nodesData
            })
        }
    }

    render() {
        // console.log("<NodebookPage> render ------------------------------------")

        if (this.state.errCode === 403) {
            return <NotFoundPage title="403" message="Nodebook is private" />
        }

        if (this.state.errCode === 404) {
            return <NotFoundPage title="404" message="Nodebook not found" />
        }

        const isEmbed = this.isEmbed()
        const isNoBackground = this.isNoBackground()

        return (
            <div className={['nodebook', isEmbed ? 'embed' : '', isNoBackground ? 'no-background' : ''].join(' ')}>
                <Header {...this.props} isNodebookPage
                    toggleSearchMode={this.toggleSearchMode}
                    nodebookExecuteSearch={this.executeSearch}
                    uberCreateNode={this.uberCreateNode}
                    publishNodebook={
                        (!(this.state.nodebookInfo.permissions && this.authLevel[this.state.nodebookInfo.permissions] > 1))
                            ? null
                            : this.publishNodebook
                    }
                />

                <div className="nodebook-wrap">
                    <div className="nodebook-sidebar-wrap" ref={c => this.nodebookSidebarWrap = c}>
                        <NodebookSidebar ref={c => this.nodebookSidebar = c}
                            nodebookInfo={this.state.nodebookInfo}
                            nodesData={this.state.nodesData}
                            templatesData={this.state.templatesData}
                            linksData={this.state.linksData}
                            linksHashTable={this.state.linksHashTable}
                            nodesHashTable={this.state.nodesHashTable}
                            isCompare={this.state.isCompare}

                            selectNode={this.selectNode}
                            selectMultipleNodes={this.selectMultipleNodes}
                            getSelection={this.getSelection}
                            selectionDeleteAll={this.selectionDeleteAll}
                            selectionUpdateAll={this.selectionUpdateAll}
                            transformToSelection={this.transformToSelection}

                            placeBasicSearch={this.placeBasicSearch}
                            updateRanks={this.updateRanks}

                            createNode={this.createNode}
                        />
                    </div>
                    <div className="nodebook-sidebar-handle" ref={c => this.nodebookHandle = c}>
                        <span className="nodebook-sidebar-hide" onClick={this.sidebarHide} ref={c => this.sidebarHideButton = c}>〈</span>
                    </div>
                    <div
                        tabIndex="-1"
                        onBlur={this.nodebookComponentOnBlur}
                        onFocus={this.nodebookComponentOnFocus}
                        onCopyCapture={this.nodebookComponentOnCopy}
                        onCutCapture={this.nodebookComponentOnCut}
                        onPasteCapture={this.nodebookComponentOnPaste}
                        onKeyDown={this.nodebookComponentKeyDown}
                        onKeyUp={this.nodebookComponentKeyUp}
                        className="nodebook-content" ref={c => this.nodebookContent = c} id="nodebookContainer"
                    >
                        <Dropzone style={{ position: "relative" }} onDrop={this.onDrop} disableClick={true} >
                            <Nodebook
                                ref={c => this.nodebookComponent = c}
                                isNoBackground={isNoBackground}
                                canEdit={this.state.nodebookInfo.canEdit}
                                nodesData={this.state.nodesData}
                                templatesData={this.state.templatesData}
                                templatesFieldList={this.templatesFieldList}
                                linksData={this.state.linksData}
                                linksHashTable={this.state.linksHashTable}
                                nodesHashTable={this.state.nodesHashTable}

                                authToken={this.state.nodebookInfo.authToken}

                                keyPressDict={this.keyPressDict}
                                nodebookid={this.props.match.params.id}
                                uberActive={this.state.searchParams.mode === 'uber'}
                                isCompare={this.state.isCompare}

                                createNode={this.createNode}
                                createLink={this.createLink}
                                canCreateLink={this.canCreateLink}

                                selectNode={this.selectNode}
                                selectMultipleNodes={this.selectMultipleNodes}
                                selectLink={this.selectLink}
                                selectionUpdateAll={this.selectionUpdateAll}
                                selectionDeleteAll={this.selectionDeleteAll}
                                getSelection={this.getSelection}
                                selectionUpdateAllLocalFirst={this.selectionUpdateAllLocalFirst}
                                updateLinksRemotely={this.updateLinksRemotely}
                                updateLinkShape={this.updateLinkShape}

                                hideCtxMenus={this.hideCtxMenus}
                                showCtxMenu={this.showCtxMenu}

                                executeSearch={this.executeSearch}

                                zoomLevelMax={this.zoomLevelMax}
                                zoomLevelMin={this.zoomLevelMin}

                                _triggerSetNodes={this._triggerSetNodes}
                            />
                            {
                                (this.state.nodesData.length === 0 && this.state.dataArrived)
                                    ? <div className="msg">
                                        Right-click to start adding nodes.<br />
                                            For more help, view the list of shortcuts (<svg style={{ margin: '0 0 2px 0', verticalAlign: 'bottom' }} width="16" height="16" viewBox="0 0 20 20">
                                            <path fill="#888" d="M17.5 16h-16c-0.827 0-1.5-0.673-1.5-1.5v-8c0-0.827 0.673-1.5 1.5-1.5h16c0.827 0 1.5 0.673 1.5 1.5v8c0 0.827-0.673 1.5-1.5 1.5zM1.5 6c-0.276 0-0.5 0.224-0.5 0.5v8c0 0.276 0.224 0.5 0.5 0.5h16c0.276 0 0.5-0.224 0.5-0.5v-8c0-0.276-0.224-0.5-0.5-0.5h-16z"></path>
                                            <path fill="#888" d="M3.5 8h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M16.5 8h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M4.5 10h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M3.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M11.5 14h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M14.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M16.5 12h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.5v-1.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M5.5 12h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                            <path fill="#888" d="M6 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M8 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M10 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M12 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M14 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M7 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M9 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M11 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M13 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M15 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M8 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M10 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                            <path fill="#888" d="M12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                        </svg>).
                                        </div>
                                    : null
                            }
                        </Dropzone>
                        {
                            (!this.state.isCompare)
                                ? <div className="nodebook-ctrls">
                                    {/* SHARE */}
                                    <div className="button" onClick={this.shareView}>
                                        Share
                                                <input tabIndex="-1" type="text" ref={c => this.shareViewLinkInput = c} />
                                    </div>
                                    {/*<div className="button" onClick={()=>{this.curveAllLinks()}}>
                                                CURVE
                                            </div>
                                            <div className="button" onClick={()=>{this.curveAllLinks(true)}}>
                                                STRAIGHTEN
                                            </div>*/}
                                    <p ref={c => this.shareMessageRef = d3.select(c)}>Link copied to clipboard.</p>
                                </div>
                                : null
                        }
                        <div className="nodebook-ctrls-zoom">
                            {/* <span><a href="https://nodebook.io" target="_blank" rel="noopener noreferrer">nodebook.io</a></span> */}
                            <span title="View shortcuts">
                                <div className="shortcuts">
                                    <div>
                                        <h2>General</h2>
                                        <p>
                                            <strong>mouse down</strong> + <strong>drag</strong> - pan<br />
                                            <strong>scroll</strong> - zoom in/out<br />
                                            <strong>F</strong> - focus selection<br />
                                            <strong>R</strong> - reset view (focus all nodes)<br />
                                            <strong>H</strong> - toggle heatmap<br />
                                            <strong>right-click</strong> - access context menu<br />
                                            <strong>Shift</strong> + <strong>drag</strong> - brush select nodes<br />
                                            <strong>Ctrl</strong> + <strong>A</strong> - select all nodes<br />
                                            <strong>click at empty area</strong> - deselect all nodes<br />
                                            <strong>Ctrl</strong> + <strong>D</strong> - deselect all nodes<br />
                                            <strong>Ctrl</strong> + <strong>C</strong> - copy selection (and their links)<br />
                                            <strong>Ctrl</strong> + <strong>V</strong> - paste (selection | url | bibtex)<br />
                                            <strong>Delete</strong> - delete selection
                                        </p>
                                    </div>
                                    <div>
                                        <h2>Nodes & links</h2>
                                        <p>
                                            <strong>Ctrl</strong> + <strong>click</strong> - toggle select<br />
                                            <strong>mouse down</strong> + <strong>drag</strong> - drag node<br />
                                            <strong>Shift</strong> + <strong>drag</strong> - drag & resize on the grid<br />
                                            hold <strong>Alt</strong> key - active <i>link creating</i><br />
                                            <strong>click at empty area</strong> - deactivate <i>link creating</i><br />
                                            <strong>drag-and-drop</strong> file - create node & upload file<br />
                                        </p>
                                        <h2>Left sidebar</h2>
                                        <p>
                                            <strong>arrow keys</strong> - traverse up/down<br />
                                            <strong>Ctrl</strong> + <strong>click</strong> - toggle select<br />
                                            <strong>Shift</strong> + <strong>click</strong> - brush select<br />
                                            click on "<strong>Filter by:</strong>" - hide filter list<br />
                                            <strong>double click</strong> - focus selection
                                        </p>
                                    </div>
                                </div>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path fill="#888" d="M17.5 16h-16c-0.827 0-1.5-0.673-1.5-1.5v-8c0-0.827 0.673-1.5 1.5-1.5h16c0.827 0 1.5 0.673 1.5 1.5v8c0 0.827-0.673 1.5-1.5 1.5zM1.5 6c-0.276 0-0.5 0.224-0.5 0.5v8c0 0.276 0.224 0.5 0.5 0.5h16c0.276 0 0.5-0.224 0.5-0.5v-8c0-0.276-0.224-0.5-0.5-0.5h-16z"></path>
                                    <path fill="#888" d="M3.5 8h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M16.5 8h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M4.5 10h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M3.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M11.5 14h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M14.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M16.5 12h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.5v-1.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M5.5 12h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M6 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M8 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M10 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M12 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M14 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M7 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M9 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M11 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M13 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M15 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M8 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M10 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                    <path fill="#888" d="M12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path>
                                </svg>
                            </span>
                            <span ref={c => this.copyBibtexRef = d3.select(c)} style={{ display: 'none' }} title="Export selection to BibTeX" onClick={this.copyBibtex}>
                                <p style={{ display: "none", position: "absolute", top: "-50px", left: "-60px" }} ref={c => this.copyBibtexMessageRef = d3.select(c)}>BibTeX copied to clipboard.</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 100 100" >
                                    <path fill="none" d="M41.6,76.9c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S44.1,76.9,41.6,76.9z" />
                                    <path fill="none" d="M41.6,89c-2.5,0-4.7-1.2-6.1-3c-1.4,1.8-3.6,3-6.1,3c-4.2,0-7.6-3.4-7.6-7.6s3.4-7.6,7.6-7.6 c2.5,0,4.7,1.2,6.1,3c1.4-1.8,3.6-3,6.1-3c4.2,0,7.6,3.4,7.6,7.6S45.8,89,41.6,89z M76.6,89H54.9c-0.9,0-1.6-0.7-1.6-1.6 s0.7-1.6,1.6-1.6h21.7c0.9,0,1.6,0.7,1.6,1.6S77.4,89,76.6,89z M76.6,83H54.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h21.7 c0.9,0,1.6,0.7,1.6,1.6S77.4,83,76.6,83z M78.1,75.3c0,0.9-0.7,1.6-1.6,1.6H54.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h21.7 C77.4,73.8,78.1,74.5,78.1,75.3z" />
                                    <path fill="none" d="M29.5,76.9c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S32,76.9,29.5,76.9z" />
                                    <path fill="#888" d="M41.6,73.8c-2.5,0-4.7,1.2-6.1,3c-1.4-1.8-3.6-3-6.1-3c-4.2,0-7.6,3.4-7.6,7.6s3.4,7.6,7.6,7.6c2.5,0,4.7-1.2,6.1-3 c1.4,1.8,3.6,3,6.1,3c4.2,0,7.6-3.4,7.6-7.6S45.8,73.8,41.6,73.8z M29.5,85.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5 S32,85.9,29.5,85.9z M41.6,85.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5S44.1,85.9,41.6,85.9z" />
                                    <path fill="#888" d="M54.9,73.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6h21.7c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6H54.9z" />
                                    <path fill="#888" d="M76.6,79.8H54.9c-0.9,0-1.6,0.7-1.6,1.6S54,83,54.9,83h21.7c0.9,0,1.6-0.7,1.6-1.6S77.4,79.8,76.6,79.8z" />
                                    <path fill="#888" d="M76.6,85.9H54.9c-0.9,0-1.6,0.7-1.6,1.6S54,89,54.9,89h21.7c0.9,0,1.6-0.7,1.6-1.6S77.4,85.9,76.6,85.9z" />
                                    <path fill="#888" d="M86.9,29.3L60.6,3c-0.4-0.4-0.9-0.5-1.4-0.4l-0.1-0.1H18.4c-3.2,0-5.8,2.6-5.8,5.8v83.5c0,3.2,2.6,5.8,5.8,5.8h63.2 c3.2,0,5.8-2.6,5.8-5.8v-61l-0.1-0.1C87.4,30.2,87.3,29.7,86.9,29.3z M62.2,9.1l18.5,18.5H64.9c-1.4,0-2.6-1.2-2.6-2.6V9.1z M81.6,94.4H18.4c-1.4,0-2.6-1.2-2.6-2.6V8.3c0-1.4,1.2-2.6,2.6-2.6h40.4l0.3,0.3V25c0,3.2,2.6,5.8,5.8,5.8h19.1l0.3,0.3v60.7 C84.2,93.2,83,94.4,81.6,94.4z" />
                                </svg>
                                {/* display:none doesn't work for textarea copy-paste */}
                                <textarea tabIndex="-1" type="text" style={{ margin: 0, padding: 0, whiteSpace: 'pre-wrap', opacity: "0", width: 0, height: 0 }} ref={c => this.bibtexCopyTextInput = c} />
                            </span>
                            <span title="Focus selection (F)" onClick={() => { this.transformToSelection() }}>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path fill="#888" d="M18.869 19.162l-5.943-6.484c1.339-1.401 2.075-3.233 2.075-5.178 0-2.003-0.78-3.887-2.197-5.303s-3.3-2.197-5.303-2.197-3.887 0.78-5.303 2.197-2.197 3.3-2.197 5.303 0.78 3.887 2.197 5.303 3.3 2.197 5.303 2.197c1.726 0 3.362-0.579 4.688-1.645l5.943 6.483c0.099 0.108 0.233 0.162 0.369 0.162 0.121 0 0.242-0.043 0.338-0.131 0.204-0.187 0.217-0.503 0.031-0.706zM1 7.5c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5-6.5-2.916-6.5-6.5z"></path>
                                </svg>
                            </span>
                            <span title="Reset view (R)" onClick={() => { this.transformToSelection(true) }}>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path fill="#888" d="M18.5 7c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.827 0 1.5 0.673 1.5 1.5v2c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M0.5 7c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.827 0.673-1.5 1.5-1.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M3.5 18h-2c-0.827 0-1.5-0.673-1.5-1.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path fill="#888" d="M17.5 18h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.827-0.673 1.5-1.5 1.5z"></path>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div className="nodebook-details-handle" ref={c => this.nodebookDetailsHandle = c}>
                        <span className="nodebook-details-hide" onClick={this.detailsHide} ref={c => this.detailsHideButton = c}>〉</span>
                    </div>
                    <div className="nodebook-details-wrap" ref={c => { this.nodebookDetailsWrap = c }}>
                        <NodebookDetails ref={c => this.nodebookDetails = c}
                            nodebookId={this.props.match.params.id}
                            nodebookInfo={this.state.nodebookInfo}
                            authLevel={this.authLevel}
                            nodesData={this.state.nodesData}
                            templatesData={this.state.templatesData}
                            linksData={this.state.linksData}
                            linksHashTable={this.state.linksHashTable}
                            nodesHashTable={this.state.nodesHashTable}
                            isCompare={this.state.isCompare}
                            keyPressDict={this.keyPressDict}
                            branchesData={this.state.branchesData}

                            selectNode={this.selectNode}
                            selectLink={this.selectLink}
                            getSelection={this.getSelection}
                            selectionDeleteAll={this.selectionDeleteAll}
                            selectionUpdateAll={this.selectionUpdateAll}
                            selectionUpdateAllLocalFirst={this.selectionUpdateAllLocalFirst}
                            updateNodesLocally={this.updateNodesLocally}
                            updateNodesRemotely={this.updateNodesRemotely}

                            placeBasicSearch={this.placeBasicSearch}

                            createNodes={this.createNodes}
                            createLink={this.createLink}
                            createLinks={this.createLinks}
                            setDefaultProps={this.setDefaults}

                            transformToSelection={this.transformToSelection}

                            auth={this.props.auth}
                            match={this.props.match}
                            history={this.props.history}

                            getShareTokenFromParams={this.getShareTokenFromParams}
                            onFileInput={this.onFileInput}
                            onNodeFileInput={this.onNodeFileInput}
                            likeNodebook={this.likeNodebook}
                            unlikeNodebook={this.unlikeNodebook}
                            subscribeNodebook={this.subscribeNodebook}
                            unsubscribeNodebook={this.unsubscribeNodebook}
                            publishNodebook={this.publishNodebook}
                            cloneNodebook={this.cloneNodebook}
                            updateNodebook={this.updateNodebook}
                            deleteNodebook={this.deleteNodebook}
                            requestMerge={this.requestMerge}
                            toggleVisibility={this.toggleVisibility}
                        />
                    </div>
                    <div className="nodebook-ctxmenu-node" ref={c => this.ctxMenuNode = d3.select(c)}>
                        <ul>
                            {this.state.nodebookInfo.canEdit
                                ? <li
                                    onClick={e => {
                                        this.hideCtxMenus()
                                        this.keyPressDict.link = true
                                    }}
                                >
                                    Link with...
                                </li> : null
                            }
                            {this.state.nodebookInfo.canEdit
                                ? <li
                                    onClick={() => {
                                        this.hideCtxMenus()
                                        var links = []
                                        this.state.selection.nodes.forEach(
                                            nodeId => {
                                                var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
                                                node.linksList.forEach(
                                                    linkId => {
                                                        var link = this.state.linksData[this.state.linksHashTable[linkId]]
                                                        var from_node = this.state.nodesData[this.state.nodesHashTable[link.from_id]]
                                                        var to_node = this.state.nodesData[this.state.nodesHashTable[link.to_id]]
                                                        if (from_node._selectionId === -1 || to_node._selectionId === -1) {
                                                            links.push(linkId)
                                                        }
                                                    }
                                                )
                                            }
                                        )
                                        this.selectionDeleteAll({
                                            nodes: [],
                                            links: links
                                        })
                                    }}
                                >
                                    Detach
                                </li>
                                : null
                            }
                            {this.state.nodebookInfo.canEdit
                                ? <li className="separator"></li> : null
                            }
                            {/*<li onClick={()=>{this.hideCtxMenus();this.sendToFront()}}>Send to Front</li>
                            <li onClick={()=>{this.hideCtxMenus();this.sendToBack()}}>Send to Back</li>
                            <li className="separator"></li>*/}
                            {/*<li onClick={e=>{
                                this.cmdCutNodes()
                            }}>Cut</li>
                            <li onClick={e=>{
                                this.cmdCopyNodes()
                            }}>Copy</li>
                            <li className="separator"></li>*/}
                            <li onClick={this.copyNodeUrl}>
                                <label >Copy node URL
                                    {/*
                                        You'd think className="kurac" would do the job here, you'd be wrong.
                                    */}
                                    <input style={{ position: 'absolute', top: '10000px', left: '10000px' }} tabIndex="-1" value={this.state.copyNodeLink} type="text" ref={c => this.copyNodeLinkInput = c} onChange={() => { }} />
                                </label>
                            </li>
                            {this.state.nodebookInfo.canEdit
                                ? <li className="separator"></li> : null
                            }
                            {this.state.nodebookInfo.canEdit
                                ? <li onClick={e => {
                                    this.hideCtxMenus()
                                    this.selectionDeleteAll()
                                }}>Delete</li> : null
                            }
                        </ul>
                    </div>
                    <div className="nodebook-ctxmenu-link" ref={c => this.ctxMenuLink = d3.select(c)}>
                        <ul>
                            <li onClick={e => {
                                this.hideCtxMenus()
                                this.selectionDeleteAll()
                            }}>Delete</li>
                        </ul>
                    </div>
                    <div className="nodebook-ctxmenu-svg" ref={c => this.ctxMenuSvg = d3.select(c)}>
                        <ul>
                            <li onClick={e => {
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'Node title',
                                        templateId: 12
                                    },
                                }])
                            }}>+ Node</li>
                            <li onClick={e => {
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        templateId: 9,
                                        title: 'Category title'
                                    },
                                }])
                            }}>+ Category</li>
                            {/*<li onClick={e=>{
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        width: 150,
                                        height: 50,
                                        title: 'Note',
                                        color: '#fdffc9',
                                        templateId: 11
                                    },
                                }])
                            }}>+ Note</li>*/}
                            <li className="separator"></li>
                            <li onClick={e => {
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'Paper title',
                                        templateId: 10
                                    },
                                }])
                            }}>+ Academic node</li>
                            {
                                /*(this.props.auth.user.username.toLowerCase()==='draganokan' || this.props.auth.user.username.toLowerCase()==='jovan')
                                    ? (
                                        <li onClick={e=>{
                                            this.hideCtxMenus()
                                            this.createNodes([{
                                                properties: {
                                                    x: this.ctxMenuData.position.x,
                                                    y: this.ctxMenuData.position.y,
                                                    title: 'New task',
                                                    templateId: 7
                                                },
                                            }])
                                        }}>+ Task</li>
                                    )
                                    : null*/
                            }
                            {
                                // (this.props.auth.user.username.toLowerCase()==='draganokan' || this.props.auth.user.username.toLowerCase()==='jovan')
                                //     ? (
                                //         <li onClick={e=>{
                                //             this.hideCtxMenus()
                                //             this.createNodes([{
                                //                 properties: {
                                //                     x: this.ctxMenuData.position.x,
                                //                     y: this.ctxMenuData.position.y,
                                //                     title: 'Image',
                                //                     templateId: 8
                                //                 },
                                //             }])
                                //         }}>+ Image</li>
                                //     )
                                //     : null
                            }
                            {/*<li onClick={e=>{
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'New node',
                                        templateId: 6
                                    },
                                }])
                            }}>+ Document</li>
                            <li onClick={e=>{
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'New label',
                                        templateId: 2
                                    },
                                }])
                            }}>+ Label</li>
                            <li className="separator"></li>
                            <li onClick={e=>{
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'New category',
                                        templateId: 1
                                    },
                                }])
                            }}>+ Category</li>
                            <li onClick={e=>{
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'New marker',
                                        templateId: 0
                                    },
                                }])
                            }}>+ Marker</li>
                            <li onClick={e=>{
                                this.hideCtxMenus()
                                this.createNodes([{
                                    properties: {
                                        x: this.ctxMenuData.position.x,
                                        y: this.ctxMenuData.position.y,
                                        title: 'New icon',
                                        templateId: 3
                                    },
                                }])
                            }}>+ Icon</li>*/}
                            <li className="separator"></li>
                            <li onClick={this.hideCtxMenus}>
                                <label className="kita">Import BibTex...
                                    <input type="file" ref={(c) => this._fileInputRef = c} multiple={false} accept=".bib" onChange={e => {
                                        this.onBibtexInput(e.target.files)
                                        this._fileInputRef.value = ''
                                    }} />
                                </label>
                            </li>
                            {/*<li className="separator"></li>
                            <li onClick={e=>{
                                this.hideCtxMenus()
                                this.cmdCopyNodebookRef()
                            }}>Copy nodebook ref</li>*/}
                            {/*<li className="separator"></li>
                            <li onClick={e=>{
                                this.hideCtxMenus()
                                this.cmdPasteNodes()
                            }}>Paste</li>*/}
                            {/*<li onClick={e=>{
                                this.hideCtxMenus()
                                this.cmdPasteNodes(true)
                            }}>Paste as ref</li>*/}
                        </ul>
                    </div>

                </div>
            </div>
        );
    }
}

export default withRouter(NodebookPage);


// WEBPACK FOOTER //
// ./src/components/NodebookPage.js